"use client";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/connector/base.ts
var BaseConnector = class {
};

// src/icons/bitget.png
var bitget_default = "data:image/png;base64,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";

// src/connector/injected.ts
var InjectedConnector = class extends BaseConnector {
  constructor(propertity) {
    var _a;
    super();
    this.propertity = propertity;
    const props = (_a = this.propertity) == null ? void 0 : _a.split(".");
    if (!this.propertity || props.length > 2) {
      throw new Error("please input valid propertity");
    }
  }
  isReady() {
    if (typeof window !== "undefined") {
      const props = this.propertity.split(".");
      if (props.length === 1) {
        return typeof window[props[0]] !== "undefined";
      } else {
        return typeof window[props[0]] !== "undefined" && typeof window[props[0]][props[1]] !== "undefined";
      }
    }
    return false;
  }
  requestAccounts() {
    return __async(this, null, function* () {
      const accounts = yield this.getProviderOrThrow().requestAccounts();
      return accounts;
    });
  }
  getAccounts() {
    return __async(this, null, function* () {
      const accounts = yield this.getProviderOrThrow().getAccounts();
      return accounts;
    });
  }
  getPublicKey() {
    return __async(this, null, function* () {
      return this.getProviderOrThrow().getPublicKey();
    });
  }
  signMessage(signStr, type) {
    return __async(this, null, function* () {
      const addresses = yield this.getAccounts();
      if (addresses.length === 0) {
        throw new Error(`${this.metadata.name} not connected!`);
      }
      return this.getProviderOrThrow().signMessage(signStr, type);
    });
  }
  on(event, handler) {
    var _a;
    const provider = this.getProvider();
    return (_a = provider == null ? void 0 : provider.on) == null ? void 0 : _a.call(provider, event, handler);
  }
  removeListener(event, handler) {
    var _a;
    const provider = this.getProvider();
    return (_a = provider == null ? void 0 : provider.removeListener) == null ? void 0 : _a.call(provider, event, handler);
  }
  getProvider() {
    if (this.isReady()) {
      const props = this.propertity.split(".");
      if (props.length === 1) {
        return window[props[0]];
      } else {
        return window[props[0]][props[1]];
      }
    }
  }
  getProviderOrThrow() {
    const provider = this.getProvider();
    if (!provider) {
      throw new Error(`${this.metadata.name} is not install or not create Bitcoin wallet!`);
    }
    return provider;
  }
  getNetwork() {
    return __async(this, null, function* () {
      return this.getProviderOrThrow().getNetwork();
    });
  }
  switchNetwork(network) {
    return __async(this, null, function* () {
      return this.getProviderOrThrow().switchNetwork(network);
    });
  }
  sendBitcoin(toAddress, satoshis, options) {
    return __async(this, null, function* () {
      return this.getProviderOrThrow().sendBitcoin(toAddress, satoshis, options);
    });
  }
  sendInscription(address, inscriptionId, options) {
    return __async(this, null, function* () {
      const result = yield this.getProviderOrThrow().sendInscription(address, inscriptionId, options);
      if (typeof result === "string") {
        return {
          txid: result
        };
      }
      return result;
    });
  }
  disconnect() {
  }
};

// src/connector/bitget.ts
var BitgetConnector = class extends InjectedConnector {
  constructor() {
    super("bitkeep.unisat");
    this.metadata = {
      id: "bitget",
      name: "Bitget Wallet",
      icon: bitget_default,
      downloadUrl: "https://web3.bitget.com/en/wallet-download"
    };
  }
};

// src/icons/bybit.png
var bybit_default = "data:image/png;base64,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";

// src/connector/bybit.ts
var BybitConnector = class extends InjectedConnector {
  constructor() {
    super("bybitWallet.bitcoin");
    this.metadata = {
      id: "bybit",
      name: "Bybit Wallet",
      icon: bybit_default,
      downloadUrl: "https://www.bybit.com/download/"
    };
  }
};

// src/icons/okx.svg
var okx_default = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiB2aWV3Qm94PSIwIDAgMTAwMCAxMDAwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB3aWR0aD0iMTAwMCIgaGVpZ2h0PSIxMDAwIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM5My45NDkgMjE4LjUxOEgyMzEuMDQ5QzIyNC4xMjkgMjE4LjUxOCAyMTguNTE5IDIyNC4xMjggMjE4LjUxOSAyMzEuMDQ4VjM5My45NDhDMjE4LjUxOSA0MDAuODY5IDIyNC4xMjkgNDA2LjQ3OSAyMzEuMDQ5IDQwNi40NzlIMzkzLjk0OUM0MDAuODcgNDA2LjQ3OSA0MDYuNDggNDAwLjg2OSA0MDYuNDggMzkzLjk0OFYyMzEuMDQ4QzQwNi40OCAyMjQuMTI4IDQwMC44NyAyMTguNTE4IDM5My45NDkgMjE4LjUxOFpNNTgxLjk5MiA0MDYuNDc5SDQxOS4wOTJDNDEyLjE3MiA0MDYuNDc5IDQwNi41NjEgNDEyLjA5IDQwNi41NjEgNDE5LjAxVjU4MS45MUM0MDYuNTYxIDU4OC44MzEgNDEyLjE3MiA1OTQuNDQxIDQxOS4wOTIgNTk0LjQ0MUg1ODEuOTkyQzU4OC45MTMgNTk0LjQ0MSA1OTQuNTIzIDU4OC44MzEgNTk0LjUyMyA1ODEuOTFWNDE5LjAxQzU5NC41MjMgNDEyLjA5IDU4OC45MTMgNDA2LjQ3OSA1ODEuOTkyIDQwNi40NzlaTTYwNi45NzQgMjE4LjUxOEg3NjkuODc0Qzc3Ni43OTQgMjE4LjUxOCA3ODIuNDA1IDIyNC4xMjggNzgyLjQwNSAyMzEuMDQ4VjM5My45NDhDNzgyLjQwNSA0MDAuODY5IDc3Ni43OTQgNDA2LjQ3OSA3NjkuODc0IDQwNi40NzlINjA2Ljk3NEM2MDAuMDUzIDQwNi40NzkgNTk0LjQ0MyA0MDAuODY5IDU5NC40NDMgMzkzLjk0OFYyMzEuMDQ4QzU5NC40NDMgMjI0LjEyOCA2MDAuMDUzIDIxOC41MTggNjA2Ljk3NCAyMTguNTE4Wk0zOTMuOTUgNTk0LjQ0MkgyMzEuMDQ5QzIyNC4xMjkgNTk0LjQ0MiAyMTguNTE5IDYwMC4wNTIgMjE4LjUxOSA2MDYuOTczVjc2OS44NzNDMjE4LjUxOSA3NzYuNzkzIDIyNC4xMjkgNzgyLjQwNCAyMzEuMDQ5IDc4Mi40MDRIMzkzLjk1QzQwMC44NyA3ODIuNDA0IDQwNi40OCA3NzYuNzkzIDQwNi40OCA3NjkuODczVjYwNi45NzNDNDA2LjQ4IDYwMC4wNTIgNDAwLjg3IDU5NC40NDIgMzkzLjk1IDU5NC40NDJaTTYwNi45NzQgNTk0LjQ0Mkg3NjkuODc0Qzc3Ni43OTQgNTk0LjQ0MiA3ODIuNDA1IDYwMC4wNTIgNzgyLjQwNSA2MDYuOTczVjc2OS44NzNDNzgyLjQwNSA3NzYuNzkzIDc3Ni43OTQgNzgyLjQwNCA3NjkuODc0IDc4Mi40MDRINjA2Ljk3NEM2MDAuMDUzIDc4Mi40MDQgNTk0LjQ0MyA3NzYuNzkzIDU5NC40NDMgNzY5Ljg3M1Y2MDYuOTczQzU5NC40NDMgNjAwLjA1MiA2MDAuMDUzIDU5NC40NDIgNjA2Ljk3NCA1OTQuNDQyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

// src/connector/okx.ts
var OKXConnector = class extends InjectedConnector {
  constructor() {
    super("okxwallet.bitcoin");
    this.metadata = {
      id: "okx",
      name: "OKX Wallet",
      icon: okx_default,
      downloadUrl: "https://www.okx.com/download"
    };
  }
};

// src/icons/tokenpocket.png
var tokenpocket_default = "data:image/png;base64,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";

// src/connector/tokenPocket.ts
var TokenPocketConnector = class extends InjectedConnector {
  constructor() {
    super("tokenpocket.bitcoin");
    this.metadata = {
      id: "tokenpocket",
      name: "TokenPocket",
      icon: tokenpocket_default,
      downloadUrl: "https://www.tokenpocket.pro/en/download/app"
    };
  }
};

// src/icons/unisat.svg
var unisat_default = "data:image/svg+xml;base64,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";

// src/connector/unisat.ts
var UnisatConnector = class extends InjectedConnector {
  constructor() {
    super("unisat");
    this.metadata = {
      id: "unisat",
      name: "Unisat Wallet",
      icon: unisat_default,
      downloadUrl: "https://unisat.io"
    };
  }
};

// src/icons/wizz.svg
var wizz_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBmaWxsPSIjRkZEODE1IiBkPSJtMjkuNjExIDE1LjU4NC0yLjU5Ny0yLjU5OC0yLjU5OCAyLjU5OCAyLjU5OCAyLjU5NyAyLjU5NyAyLjU5NyAyLjU5Ny0yLjU5N3oiLz48cGF0aCBmaWxsPSIjRkY5ODEzIiBkPSJtMjkuNjExIDAtMi41OTggMi41OTcgMi41OTggMi41OTggMi41OTctMi41OTh6TTQwIDEwLjM4OWwtMi41OTctMi41OTctMi41OTggMi41OTcgMi41OTggMi41OTh6TTI0LjQxNiAzMS4xNjhsMi41OTggMi41OTcgMi41OTctMi41OTctMi41OTctMi41OTh6TTYuMjM1IDEyLjk4NmwyLjU5OCAyLjU5OCAyLjU5Ny0yLjU5OC0yLjU5Ny0yLjU5N3pNMTkuMjIyIDBsLTIuNTk4IDIuNTk3IDIuNTk4IDIuNTk4IDIuNTk3LTIuNTk4ek04LjgzMyA1LjE5NWwyLjU5NyAyLjU5NyAyLjU5Ny0yLjU5Ny0yLjU5Ny0yLjU5OHpNMzcuNDAzIDE4LjE4MWwtMi41OTggMi41OTcgMi41OTggMi41OThMNDAgMjAuNzc4ek0zMi4yMDggMjguNTdsMi41OTcgMi41OTggMi41OTgtMi41OTgtMi41OTgtMi41OTd6Ii8+PHBhdGggZmlsbD0iIzVCNUI3MiIgZD0ibTI5LjYxMSAyMC43NzgtMi41OTctMi41OTctMi41OTggMi41OTctMi41OTctMi41OTctMi41OTctMi41OTcgMi41OTctMi41OTgtMi41OTctMi41OTctMi41OTgtMi41OTctMi41OTcgMi41OTcgMi41OTcgMi41OTctMi41OTcgMi41OTggMi41OTcgMi41OTctMi41OTcgMi41OTctMS4yOTktMS4yOTgtMi41OTcgMi41OTcgMi41OTcgMi41OTctMi41OTcgMi41OTgtMi40NjggMi40NjgtMi40NjggMi40NjgtMi41OTggMi41OThMMCAzNy40MDMgMi41OTcgNDBsMi41OTgtMi41OTcgMi41OTctMi41OTcgMi40NjgtMi40NjkuMTI5LS4xMjkgMi4zMzktMi4zMzkuMTI5LS4xMjkgMi40NjktMi40NjggMi41OTcgMi41OTcgMi41OTctMi41OTctMS4yOTgtMS4yOTkgMi41OTctMi41OTcgMi41OTcgMi41OTcgMi41OTgtMi41OTcgMi41OTcgMi41OTcgMi41OTctMi41OTd6Ii8+PHBhdGggZmlsbD0iI0ZGOTgxMyIgZD0ibTI5LjYxMSAxMC4zODktMi41OTctMi41OTctMi41OTggMi41OTctMi41OTctMi41OTctMi41OTcgMi41OTcgMi41OTcgMi41OTgtMi41OTcgMi41OTcgMi41OTcgMi41OTcgMi41OTcgMi41OTcgMi41OTgtMi41OTctMi41OTgtMi41OTcgMi41OTgtMi41OTcgMi41OTcgMi41OTcgMi41OTctMi41OTd6Ii8+PC9nPjwvc3ZnPgo=";

// src/connector/wizz.ts
var WizzConnector = class extends InjectedConnector {
  constructor() {
    super("wizz");
    this.metadata = {
      id: "wizz",
      name: "Wizz Wallet",
      icon: wizz_default,
      downloadUrl: "https://wizzwallet.io"
    };
  }
};

// src/connector/xverse.ts
import EventEmitter from "events";

// src/icons/xverse.png
var xverse_default = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAALhUlEQVR4nO2dT2wc1R3Hv7+dFk/kN8u2tdBsLJThUCm0SNhCKn8utcWFG644wCk4p4I4JBZIKb2YnEokIpJbgaomioTKIWJzA6lVHFUy9JRNRapU5TA0sj3igMbOa7uO2H095D2zXu+/2Z0/783OR7IcrzzzXvz9zJs3b968IeQQ13W9Uqk0J4TwABwTQlQAePILbd878YkoFEKERBQC8AF8LYSoW5YVbm5u1lP8b6QCZV2BcXFd1wOwQESPA1gA4MnAY0fKUSeiOhFdb7Va9SAI/CTKSgvjBPA8r9JoNOaI6HkhxFKfozkViKguhKgDuBQEwXqWdRkFYwRwXXcBwMtEtJTUET4usoWolUqlq1tbW7Ws6zMMWgswOzs712w2nyei07qG3gcfwDqAszqfJrQUQB7tq/KcngeUCNqdIrQSIIfBd+JLET7MuiIKLQSYgOA70UaETAWQl3BrExT8AYioJoRYybKPYGVRqOd5Fdu2zwCoZX0ZlzHHAZxmjGFmZuZmGIaNtCuQegsgm/u1CQ++Gz6Ak2l3FFNrATzPqxw5cuR3AH4PwLRLujSoAFh2HKfCOf8srUJTaQHkuf5acdQPjQ9gMY2+QSnpAlzXfZmIbhThR8IjohvVavV00gUlegqoVqvvAngbgJ1kOTnFBvAcYwyc8+tJFZLIKcDzvMre3t6avFlTMCZEVJuamjrp+34Y+77j3qHruh4RfSKEmIt73xNOIv2CWAUoOnuJE7sEsQlQhJ8asUoQiwBF+KkTmwRjC1CEnxmxSDDWOIDneZUi/MzwiOgTmcHIjCXA3t5eMaafIUKIOZnByIw8EOS67iqAV8YpvCAWjo9z/2AkAarV6ik5wlegB08xxnzO+c2oG0buBMqBnhsGTtLMNXJG8nzUTuEofYBrRfj6ITO5FrVTGEkAeXOn6PTpi7e3t7caZYOhTwFyJs+1karVxpUrV/DMM89E3m53dxfvv/8+zp8/P24VEuW1eYYTP5+G80D/P+3dewJ377UOfPbnf+/h7S9246jG4rAzi4YSQD6OFcs9/e3t7bG2f+edd7SV4LV5htfm2Vj7+Nkfgziq4tu2PT/M3cOhTgGNRuOULk3/G2+8gddffz3rahwijvBjxGs0GkNNJhkogBzqfSuOWsWFbhJoFr5iVWbXl4ECENG7sVUpRnSRQNPwFQNHCfsK4Lruss6zerKWQPPwAWBBdt57MqgFiHRJkQVZSWBA+Iq+GfYUwHXdZV06foNIWwKDwsegVqBfC6D90d9OWhIYFr6iZ5ZdBZDGGHH0t5O0BIaGj36tQK8WwKijv52kJDA4fEXXTA8JoFbdSqVKCRG3BDkIHwAWZmdnD03V79YCGHv0txOXBDkJHwDQbDYPXdJ3EyDRo393N5abHUMxrgR5Ch/3B/VOdX52YEbQ0aNHl4QQiU7zsm17pLuBo6LK+vzzzyNtl0X4d+8J/OHv/0myCJsxdp1zvj9p5IAA09PTZwAk+kjXxsYGiEhrCZZ+egRvPllOuFaHObuxi9vffpd4OZzzq+rfBwRwHOfDNJ7k1V2CZ4/Z+EX1gRRq9T2//esOav/6X+LlEJE3MzPznlqOZn8+QFwTPqKQxTDusPMJogpw5skyHv3xD0aqU1rht7E/YWS/BWCMrSbd/Heic0uwyZuRvu41BZ49Fr3xzCB8ENEO5/xTtAvgOM5bANxUa6K5BFE4/pMfRhYgi/AlLuf8IpQAcvAns3n+eZAgqgAZhg8AFcbYJc55aAFAuVxeEEK8lFVtkAMJogiQcfiKm5zzuoX75/9XADyVdY1MlmBYATQJH0T0Nef8UyXAGV3u/pkqwTAC6BI+7gtgc87fs3C/A3hBp5W8TJRgkAA6hY/vBThnzc7OzrVarcTXo4uKaRL0E0C38CU2Y+ySNT09fRzActa16YZJEvQSQNPwAQClUum65TjOEoDnsq5ML0yRoJsAOocv+ZvlOM5LOlwB9MMECToFMCB8ENE/Lcdxfi3Xrdca3SVoF8CE8CW3LTkGoMUl4CB0luD2t99hizdx+R//xV++3kupdmMTWo7jnM7iHsCo6C7BJm+mVKt4sBhjvzHtBQ46S2AYocUYu5B1LUahkCAWKhZjTKtHv6OwsbGBBx98EE888URqZeZNAqMFAIBvvvkGJ06cSLXMPElgtADlchlra2t46KGHUi87LxIYK0C5XMaVK1fw2GOPZVaHPEhgpAA6hK8wXQKLMbZs0mWgTuErDJbAtxhjp00RQMfwFSZKQES+xRhbMmEoWOfwFQZKcNtijC2m/TxAVEwIX2GSBER003IcZ0Hn28Emha8wRQIi+sxyHOe4rhNCTAxfYYIERPSxVS6X3ayfCeiGyeErDJDgnDU9Pd0AoNWk0DyEr9BZAsuyLlqc81DOCdBiWniewlfoKAERhVtbWyvquYCXdJgUksfwFRpK8AXn/JIS4NGsrwTyHL5CJwmI6Gr7o2EugMwWhc4q/C+//BJfffUVHn744dTK1EWCUql07u7du7eVAGFWHcEsw3/hhRdw+fLliZxZJIR4c//xcM55mMVNoazDV0vWTdr0MiKqB0FwDh0rhDySZj9Al/AVEybBp2qlsPY1ghppPSOoW/iKCZJgRa0VuC/AzMxM2Gw2X0l6PEDX8BV5l4CIwiAIXlU/7wsQhmGDMfZo0ncGP/roo1Rn8SJC+IqsJLhz5w5u3bqVdFF/al8osnOt4A+TLj3NPypGCF+RxfsJ0/jblEqlqwd+bv8hCIJ1Ihr4skFTGDV8hc4vqRwRf2trq9b+waHVwoUQF1OtUkKMG74iZxIcep3sIQEsy6p1fmYacYWvyJEEZzs/OCTA5uZmvZspphB3+IocSLAeBIHf+WGvdwYdMsUUVlZWEnspheESdM20qwByJWkjW4GdnZ1E92+oBH6v18n3e2+gsa1A0hgoQc8sewpgciuQBgZJ4AdB0HN8Z9C7g4tWoA+GSNA3w74CFK3AYHSWgIhq/Y5+DNECAMDJ+KqUT3SVQAixMuh3Bgogrx2LU8EANJTgbLfr/k6GaQFg2/YFAAN3NuloJIEvMxsIDfE7QIxvFXvxxRfx9NNPj7ubrty6dQsffPBBIvuOwqj/x/Pnz+POnTtxVGGx13V/J0MLAADVavWCEOLQ60cL9IGILm5vbw89wTeSAJ7nVRqNxg0T1hOYUPwgCB6JssFQfYD9vft+CGAxT3MG8oLMZDHqdpEEgLwqGObyoiB1hur1d2IN8TuH4JzXHcf5UdaPkxXsczYIgpHe+xipD9BJtVr9RAiR2SNlBfdH+7a3t3816vaRTwHtTE1NnSSi+jj7KBgLf2pqaqyR2rFaAHz/2tlrxZVB6vjyen+sAbqxBUAhQRbEEj7iEgCFBGkSW/iIUwAUEqRBrOFj3E5gJ7Jii8WNo/iRne1Yw0fcAkBKYNv2PBEZ/3yBLhBRbWpqKvbwMepA0CDCMGxwzj9mjBGAhSTKmBTkzZ2TYRg2kth/IgIoOOfrjuPsENFTuixDZwpybP/VUUf4hi4nyZ0ris5hZGLv7PUi9j5AN4Ig8IMgeISIcvHgaZIQ0UXbtufTCB9ptQDtyJlFa0VrcAgfwMlhZ/LERSotQDtBEKzbtj1fTDQ9wFl51Kc+BT/1FqAd13U9Inp3gu8orsujPrNxk0wFULiuuwxgdYJOC+vyHn7mD91oIYBiAkTQJniFVgIoZEdxNUeDSNoFr9BSAIUcP3gLwC9NaxWIKBRCXLQsqyZXXdESrQVo5+jRo0utVmuJiJ4XQmj5nkMZeg3AJR2P9m4YI0A78hSxTESPCyGyfuWdT0RXhRA127brcuq8MRgpQDuu63qlUmlOCLEghHiciOaSaiHk+LwP4LoQot5r4SWTMF6AbszOzs41m80KEc3JvsMxIUSFiCpSjl79Cb/tu09EO/K732q16qaH3Y3/A6eWgM0UqgCVAAAAAElFTkSuQmCC";

// src/connector/xverse.ts
var _network, _event;
var XverseConnector = class extends BaseConnector {
  constructor() {
    super();
    __privateAdd(this, _network, "Mainnet");
    __privateAdd(this, _event, new EventEmitter());
    this.metadata = {
      id: "xverse",
      name: "Xverse Wallet",
      icon: xverse_default,
      downloadUrl: "https://www.xverse.app"
    };
    this.loadAccounts = (network) => __async(this, null, function* () {
      const { getAddress, AddressPurpose } = yield import("sats-connect");
      const addresses = yield new Promise((resolve, reject) => {
        const getAddressOptions = {
          payload: {
            purposes: [AddressPurpose.Payment, AddressPurpose.Ordinals],
            message: "Address for receiving Ordinals and payments",
            network: {
              type: network
            }
          },
          onFinish: (response) => {
            resolve(response.addresses);
          },
          onCancel: () => reject({
            code: 4001,
            message: "User rejected the request."
          })
        };
        getAddress(getAddressOptions).catch((error) => reject(error));
      });
      localStorage.setItem("btc-connect-xverse-addresses-" + network, JSON.stringify(addresses));
      return addresses;
    });
    __privateGet(this, _event).setMaxListeners(100);
  }
  isReady() {
    return typeof window !== "undefined" && typeof window.BitcoinProvider !== "undefined";
  }
  sendInscription() {
    return __async(this, null, function* () {
      throw new Error("Unsupported");
    });
  }
  requestAccounts() {
    return __async(this, null, function* () {
      if (!this.isReady()) {
        throw new Error(`${this.metadata.name} is not install!`);
      }
      const addresses = yield this.loadAccounts(__privateGet(this, _network));
      return addresses.map((item) => item.address);
    });
  }
  getAccounts() {
    return __async(this, null, function* () {
      if (!this.isReady()) {
        throw new Error(`${this.metadata.name} is not install!`);
      }
      const data = localStorage.getItem("btc-connect-xverse-addresses-" + __privateGet(this, _network));
      if (data) {
        const addresses = JSON.parse(data);
        return addresses.map((item) => item.address);
      } else {
        return [];
      }
    });
  }
  getPublicKey() {
    return __async(this, null, function* () {
      if (!this.isReady()) {
        throw new Error(`${this.metadata.name} is not install!`);
      }
      const data = localStorage.getItem("btc-connect-xverse-addresses-" + __privateGet(this, _network));
      if (data) {
        const addresses = JSON.parse(data);
        return addresses[0].publicKey;
      } else {
        return "";
      }
    });
  }
  signMessage(signStr) {
    return __async(this, null, function* () {
      if (!this.isReady()) {
        throw new Error(`${this.metadata.name} is not install!`);
      }
      const addresses = yield this.getAccounts();
      if (addresses.length === 0) {
        throw new Error(`${this.metadata.name} not connected!`);
      }
      const { signMessage } = yield import("sats-connect");
      const sig = yield new Promise((resolve, reject) => {
        const signMessageOptions = {
          payload: {
            network: {
              type: __privateGet(this, _network)
            },
            address: addresses[0],
            message: signStr
          },
          onFinish: (response) => {
            resolve(response);
          },
          onCancel: () => {
            reject({
              code: 4001,
              message: "User rejected the request."
            });
          }
        };
        signMessage(signMessageOptions).catch((e) => {
          reject(e);
        });
      });
      const modifiedSig = Buffer.from(sig, "base64");
      modifiedSig[0] = 31 + (modifiedSig[0] - 31) % 4;
      return modifiedSig.toString("base64");
    });
  }
  on(event, handler) {
    return __privateGet(this, _event).on(event, handler);
  }
  removeListener(event, handler) {
    return __privateGet(this, _event).removeListener(event, handler);
  }
  getProvider() {
    if (this.isReady()) {
      return window.BitcoinProvider;
    }
  }
  getNetwork() {
    return __async(this, null, function* () {
      if (!this.isReady()) {
        throw new Error(`${this.metadata.name} is not install!`);
      }
      return __privateGet(this, _network) === "Mainnet" ? "livenet" : "testnet";
    });
  }
  switchNetwork() {
    return __async(this, null, function* () {
      throw new Error("Unsupported");
    });
  }
  sendBitcoin(toAddress, satoshis) {
    return __async(this, null, function* () {
      const provider = this.getProvider();
      if (!provider) {
        throw new Error(`${this.metadata.name} is not install!`);
      }
      const { sendBtcTransaction } = yield import("sats-connect");
      const addresses = yield this.getAccounts();
      if (addresses.length === 0) {
        throw new Error(`${this.metadata.name} not connected!`);
      }
      const result = yield new Promise((resolve, reject) => {
        const sendBtcOptions = {
          payload: {
            network: {
              type: __privateGet(this, _network)
            },
            recipients: [
              {
                address: toAddress,
                amountSats: BigInt(satoshis)
              }
            ],
            senderAddress: addresses[0]
          },
          onFinish: (response) => {
            resolve(response);
          },
          onCancel: () => {
            reject({
              code: 4001,
              message: "User rejected the request."
            });
          }
        };
        sendBtcTransaction(sendBtcOptions).catch((e) => reject(e));
      });
      return result;
    });
  }
  disconnect() {
    localStorage.removeItem("btc-connect-xverse-addresses-Mainnet");
    localStorage.removeItem("btc-connect-xverse-addresses-Testnet");
  }
};
_network = new WeakMap();
_event = new WeakMap();

// src/context/index.tsx
import { SmartAccount } from "@particle-network/aa";
import { chains as chains4 } from "@particle-network/chains";
import { walletEntryPlugin } from "@particle-network/wallet";
import { createContext, useCallback as useCallback8, useContext, useEffect as useEffect5, useMemo as useMemo6, useState as useState7 } from "react";

// src/components/connectModal/index.tsx
import { useEffect as useEffect3, useState as useState3 } from "react";

// src/hooks/useAccountContract.ts
var useAccountContract = () => {
  const { accountContract, setAccountContract } = useConnectProvider();
  return {
    accountContract,
    setAccountContract
  };
};

// src/hooks/useAccounts.ts
var useAccounts = () => {
  const { accounts } = useConnectProvider();
  return { accounts };
};

// src/hooks/useBTCProvider.ts
import { useCallback } from "react";
var useBTCProvider = () => {
  const { connector, provider, accounts, getPublicKey, signMessage, getNetwork, switchNetwork, sendBitcoin } = useConnectProvider();
  const sendInscription = useCallback(
    (address, inscriptionId, options) => __async(void 0, null, function* () {
      if (!connector) {
        throw new Error("Wallet not connected!");
      }
      const result = yield connector.sendInscription(address, inscriptionId, options);
      return result;
    }),
    [connector]
  );
  return { provider, accounts, getPublicKey, signMessage, getNetwork, switchNetwork, sendBitcoin, sendInscription };
};

// src/hooks/useConnectModal.ts
import { useCallback as useCallback2, useMemo } from "react";

// src/utils/eventUtils.ts
import { EventEmitter as EventEmitter2 } from "events";
var events = new EventEmitter2();
events.setMaxListeners(100);
var getPendingSignEventAccount = () => {
  return events.listenerCount("sendUserOpResult" /* sendUserOpResult */) + events.listenerCount("personalSignResult" /* personalSignResult */) + events.listenerCount("signTypedDataResult" /* signTypedDataResult */);
};
var eventUtils_default = events;

// src/hooks/useConnectModal.ts
var useConnectModal = () => {
  const { openConnectModal: _openConnectModal, disconnect: _disconnect } = useConnectProvider();
  const { accounts } = useAccounts();
  const connect = useCallback2(() => __async(void 0, null, function* () {
    return new Promise((resolve, reject) => {
      const onConnectResult = ({ result, error }) => {
        if (result) {
          resolve(result);
        } else {
          reject(error);
        }
      };
      eventUtils_default.once("connectResult" /* connectResult */, onConnectResult);
      _openConnectModal();
    });
  }), [_openConnectModal]);
  const openConnectModalAsync = useMemo(() => {
    if (accounts.length > 0) {
      return void 0;
    } else {
      return connect;
    }
  }, [accounts, connect]);
  const disconnect = useMemo(() => {
    if (accounts.length > 0) {
      return _disconnect;
    } else {
      return void 0;
    }
  }, [accounts, _disconnect]);
  const openConnectModal = useMemo(() => {
    if (accounts.length > 0) {
      return void 0;
    } else {
      return _openConnectModal;
    }
  }, [accounts, _openConnectModal]);
  return { openConnectModal, openConnectModalAsync, disconnect };
};

// src/hooks/useConnector.ts
import { useCallback as useCallback3 } from "react";
var useConnector = () => {
  const { connectors, setConnectorId } = useConnectProvider();
  const connect = useCallback3(
    (connectorId) => __async(void 0, null, function* () {
      const connector = connectors.find((item) => item.metadata.id === connectorId);
      if (!connector) {
        throw new Error(`connector id ${connectorId} not found`);
      }
      const accounts = yield connector.requestAccounts();
      if (accounts.length > 0) {
        localStorage.setItem("current-connector-id", connector.metadata.id);
        setConnectorId(connector.metadata.id);
      }
      return accounts;
    }),
    [connectors, setConnectorId]
  );
  return { connectors, connect };
};

// src/hooks/useETHProvider.ts
import { intToHex } from "@ethereumjs/util";
import { useCallback as useCallback4, useEffect, useMemo as useMemo2, useState } from "react";
import { createWalletClient, custom } from "viem";

// src/evmSigner/provider.ts
var EthereumProvider = class {
  constructor(sendUserOp, signer, account) {
    this.sendUserOp = sendUserOp;
    this.signer = signer;
    this.account = account;
  }
  on(event, listener) {
    var _a;
    (_a = this.signer) == null ? void 0 : _a.on(event, listener);
    return this;
  }
  once(event, listener) {
    var _a;
    (_a = this.signer) == null ? void 0 : _a.once(event, listener);
    return this;
  }
  off(event, listener) {
    var _a;
    (_a = this.signer) == null ? void 0 : _a.off(event, listener);
    return this;
  }
  removeListener(event, listener) {
    var _a;
    (_a = this.signer) == null ? void 0 : _a.removeListener(event, listener);
    return this;
  }
  request(arg) {
    return __async(this, null, function* () {
      var _a, _b;
      const method = arg.method;
      if (!method) {
        throw new Error("Method not found.");
      }
      if (method === "eth_accounts" || method === "eth_requestAccounts") {
        return this.account ? [this.account] : [];
      } else if (method === "eth_sendTransaction") {
        const txData = (_a = arg.params) == null ? void 0 : _a[0];
        const result = yield this.sendUserOp({ tx: txData });
        return result;
      }
      return (_b = this.signer) == null ? void 0 : _b.request(arg);
    });
  }
};

// src/utils/txConfirmUtils.ts
var txConfirm = {
  isNotRemind: () => {
    if (typeof window === "undefined")
      return false;
    const value = localStorage.getItem("tx-confirm-modal-remind");
    return value === "0";
  },
  setNotRemind: (notRemind) => {
    if (typeof window === "undefined")
      return;
    if (notRemind) {
      localStorage.setItem("tx-confirm-modal-remind", "0");
    } else {
      localStorage.removeItem("tx-confirm-modal-remind");
    }
  },
  reset: () => {
    if (typeof window === "undefined")
      return;
    localStorage.removeItem("tx-confirm-modal-remind");
  }
};
var txConfirmUtils_default = txConfirm;

// src/evmSigner/walletClientProvider.ts
var WalletClientProvider = class {
  constructor(provider) {
    this.provider = provider;
  }
  on(event, listener) {
    this.provider.on(event, listener);
    return this;
  }
  once(event, listener) {
    this.provider.once(event, listener);
    return this;
  }
  off(event, listener) {
    this.provider.off(event, listener);
    return this;
  }
  removeListener(event, listener) {
    this.provider.removeListener(event, listener);
    return this;
  }
  request(arg) {
    return __async(this, null, function* () {
      const method = arg.method;
      if (!method) {
        throw new Error("Method not found.");
      }
      if (method === "personal_sign" /* personalSign */ || method.startsWith("eth_signTypedData" /* signTypedData */)) {
        const showConfirmModal = !txConfirmUtils_default.isNotRemind();
        if (showConfirmModal) {
          if (getPendingSignEventAccount() > 0) {
            throw new Error("Operation failed, there is a transaction being processed");
          }
        }
        if (!showConfirmModal) {
          return this.provider.request(arg);
        }
      }
      if (method === "personal_sign" /* personalSign */) {
        return new Promise((resolve, reject) => {
          eventUtils_default.emit("personalSign" /* personalSign */, arg);
          eventUtils_default.once("personalSignResult" /* personalSignResult */, ({ result, error }) => {
            if (result) {
              resolve(result);
            } else {
              reject(error);
            }
          });
        });
      } else if (method.startsWith("eth_signTypedData" /* signTypedData */)) {
        return new Promise((resolve, reject) => {
          eventUtils_default.emit("signTypedData" /* signTypedData */, arg);
          eventUtils_default.once("signTypedDataResult" /* signTypedDataResult */, ({ result, error }) => {
            if (result) {
              resolve(result);
            } else {
              reject(error);
            }
          });
        });
      }
      return this.provider.request(arg);
    });
  }
};

// src/hooks/useETHProvider.ts
var useETHProvider = () => {
  const { evmAccount, smartAccount, getSmartAccountInfo } = useConnectProvider();
  const [chainId, setChainId] = useState();
  useEffect(() => {
    if (smartAccount) {
      const chainId2 = smartAccount.provider.chainId;
      setChainId(chainId2);
      const onChangeChange = (id) => {
        setChainId(Number(id));
      };
      smartAccount.provider.on("chainChanged", onChangeChange);
      return () => {
        smartAccount.provider.removeListener("chainChanged", onChangeChange);
      };
    }
  }, [smartAccount]);
  const switchChain = useCallback4(
    (chainId2) => __async(void 0, null, function* () {
      if (smartAccount == null ? void 0 : smartAccount.provider) {
        yield smartAccount.provider.request({
          method: "wallet_switchEthereumChain",
          params: [
            {
              chainId: intToHex(chainId2)
            }
          ]
        });
      }
    }),
    [smartAccount == null ? void 0 : smartAccount.provider]
  );
  const getFeeQuotes = useCallback4(
    (tx) => __async(void 0, null, function* () {
      if (!smartAccount) {
        throw new Error("The smart account is not initialized.");
      }
      return smartAccount.getFeeQuotes(tx);
    }),
    [smartAccount]
  );
  const buildUserOp = useCallback4(
    (_0) => __async(void 0, [_0], function* ({ tx, feeQuote, tokenPaymasterAddress }) {
      if (!smartAccount) {
        throw new Error("The smart account is not initialized.");
      }
      const result = yield smartAccount.buildUserOperation({ tx, feeQuote, tokenPaymasterAddress });
      return result;
    }),
    [smartAccount]
  );
  const sendUserOp = useCallback4(
    (params, forceHideConfirmModal) => __async(void 0, null, function* () {
      if (!smartAccount) {
        throw new Error("The smart account is not initialized.");
      }
      const showConfirmModal = !forceHideConfirmModal && !txConfirmUtils_default.isNotRemind();
      if (showConfirmModal) {
        if (getPendingSignEventAccount() > 0) {
          throw new Error("Operation failed, there is a transaction being processed");
        }
      }
      let userOpBundle;
      if (Object.prototype.hasOwnProperty.call(params, "userOpHash") && Object.prototype.hasOwnProperty.call(params, "userOp")) {
        const { userOpHash, userOp } = params;
        if (userOpHash && userOp) {
          userOpBundle = { userOpHash, userOp };
        }
      }
      if (!userOpBundle) {
        const { tx, feeQuote, tokenPaymasterAddress } = params;
        userOpBundle = yield buildUserOp({ tx, feeQuote, tokenPaymasterAddress });
      }
      if (!showConfirmModal) {
        return smartAccount.sendUserOperation(userOpBundle);
      }
      return new Promise((resolve, reject) => {
        eventUtils_default.emit("sendUserOp" /* sendUserOp */, userOpBundle);
        eventUtils_default.once("sendUserOpResult" /* sendUserOpResult */, ({ result, error }) => {
          if (result) {
            resolve(result);
          } else {
            reject(error);
          }
        });
      });
    }),
    [smartAccount, buildUserOp]
  );
  const publicClient = useMemo2(() => {
    if (!smartAccount || !chainId) {
      return void 0;
    }
    return (smartAccount == null ? void 0 : smartAccount.provider).publicClient;
  }, [smartAccount, chainId]);
  const provider = useMemo2(() => {
    const ethereumProvider = new EthereumProvider(sendUserOp, smartAccount == null ? void 0 : smartAccount.provider, evmAccount);
    return ethereumProvider;
  }, [evmAccount, sendUserOp, smartAccount == null ? void 0 : smartAccount.provider]);
  const walletClient = useMemo2(() => {
    return createWalletClient({
      transport: custom(new WalletClientProvider(provider))
    });
  }, [provider]);
  return {
    provider,
    evmAccount,
    account: evmAccount,
    getSmartAccountInfo,
    switchChain,
    chainId,
    getFeeQuotes,
    buildUserOp,
    sendUserOp,
    publicClient,
    walletClient
  };
};

// src/icons/back.svg
var back_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik00MDAtODAgMC00ODBsNDAwLTQwMCA3MSA3MS0zMjkgMzI5IDMyOSAzMjktNzEgNzFaIiBmaWxsPSJ3aGl0ZSIvPjwvc3ZnPg==";

// src/icons/close.svg
var close_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Im0yNTYtMjAwLTU2LTU2IDIyNC0yMjQtMjI0LTIyNCA1Ni01NiAyMjQgMjI0IDIyNC0yMjQgNTYgNTYtMjI0IDIyNCAyMjQgMjI0LTU2IDU2LTIyNC0yMjQtMjI0IDIyNFoiIGZpbGw9IndoaXRlIi8+PC9zdmc+";

// src/icons/retry.svg
var retry_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik00ODAtMTYwcS0xMzQgMC0yMjctOTN0LTkzLTIyN3EwLTEzNCA5My0yMjd0MjI3LTkzcTY5IDAgMTMyIDI4LjVUNzIwLTY5MHYtMTEwaDgwdjI4MEg1MjB2LTgwaDE2OHEtMzItNTYtODcuNS04OFQ0ODAtNzIwcS0xMDAgMC0xNzAgNzB0LTcwIDE3MHEwIDEwMCA3MCAxNzB0MTcwIDcwcTc3IDAgMTM5LTQ0dDg3LTExNmg4NHEtMjggMTA2LTExNCAxNzN0LTE5NiA2N1oiIGZpbGw9IndoaXRlIi8+PC9zdmc+";

// esbuild-scss-modules-plugin:./spinner.module.scss
var digest = "906d42389ecad5c2ab92642c8e0775ea667c413b069684ce9d01199562f2d0be";
var classes = { "loader": "_loader_g0am3_1", "rotate": "_rotate_g0am3_1", "prixClipFix": "_prixClipFix_g0am3_1" };
var css = `._loader_g0am3_1{animation:_rotate_g0am3_1 1s linear infinite;border-radius:50%;height:20px;position:relative;width:20px}._loader_g0am3_1:before{animation:_prixClipFix_g0am3_1 2s linear infinite;border:2px solid #000;border-radius:50%;box-sizing:border-box;content:"";inset:0;position:absolute}@keyframes _rotate_g0am3_1{to{transform:rotate(1turn)}}@keyframes _prixClipFix_g0am3_1{0%{clip-path:polygon(50% 50%,0 0,0 0,0 0,0 0,0 0)}25%{clip-path:polygon(50% 50%,0 0,100% 0,100% 0,100% 0,100% 0)}50%{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,100% 100%,100% 100%)}75%{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 100%)}to{clip-path:polygon(50% 50%,0 0,100% 0,100% 100%,0 100%,0 0)}}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement("style");
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();
var spinner_module_default = classes;

// src/components/spinner/index.tsx
import { jsx } from "react/jsx-runtime";
var Spinner = ({ className, style }) => {
  return /* @__PURE__ */ jsx("span", { className: spinner_module_default.loader + (className ? ` ${className}` : ""), style });
};
var spinner_default = Spinner;

// esbuild-scss-modules-plugin:./button.module.scss
var digest2 = "424d614dbc2763d7cad7ca35c00bd255c6ed55da308a1f3018594201a47127bf";
var classes2 = { "btn": "_btn_ofd87_1" };
var css2 = `._btn_ofd87_1{align-items:center;background:#fff;border-radius:8px;color:#000;display:flex;flex-direction:row;font-size:16px;gap:16px;justify-content:center;padding:6px 24px;position:relative}._btn_ofd87_1:hover{opacity:.85}._btn_ofd87_1:disabled{background:hsla(0,0%,100%,.2);color:hsla(0,0%,100%,.639);cursor:not-allowed;opacity:1}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest2)) {
    var ele = document.createElement("style");
    ele.id = digest2;
    ele.textContent = css2;
    document.head.appendChild(ele);
  }
})();
var button_module_default = classes2;

// src/components/button/index.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var Button = ({
  children,
  isLoading,
  isDisabled,
  onClick,
  className,
  style
}) => {
  return /* @__PURE__ */ jsxs(
    "button",
    {
      className: button_module_default.btn + (className ? ` ${className}` : ""),
      onClick: isLoading || isDisabled ? void 0 : onClick,
      disabled: isDisabled,
      style,
      children: [
        isLoading && !isDisabled && /* @__PURE__ */ jsx2(spinner_default, {}),
        children
      ]
    }
  );
};
var button_default = Button;

// src/components/modal/index.tsx
import { useEffect as useEffect2, useMemo as useMemo3, useState as useState2 } from "react";
import { createPortal } from "react-dom";
import { RemoveScroll } from "react-remove-scroll";

// esbuild-scss-modules-plugin:./modal.module.scss
var digest3 = "65eada90924218eba4e72a5f00291c3cb69387ecce1351e454cdefd066d4bcff";
var classes3 = { "container": "_container_smzpm_1", "modal": "_modal_smzpm_18" };
var css3 = `._container_smzpm_1{align-items:center;backdrop-filter:blur(12px);background:rgba(0,0,0,.502);bottom:0;color:#fff;display:flex;height:100%;justify-content:center;left:0;overflow:hidden;position:fixed;right:0;top:0;width:100%;z-index:100000}._container_smzpm_1 ._modal_smzpm_18{align-items:center;background-color:#171a1f;border-radius:16px;display:flex;flex-direction:column;font-size:14px;height:auto;margin:16px;max-height:80%;max-width:100%;overflow:auto;padding:24px;position:relative;width:380px}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest3)) {
    var ele = document.createElement("style");
    ele.id = digest3;
    ele.textContent = css3;
    document.head.appendChild(ele);
  }
})();
var modal_module_default = classes3;

// src/components/modal/index.tsx
import { Fragment, jsx as jsx3 } from "react/jsx-runtime";
var stopPropagation = (event) => event.stopPropagation();
var Modal = ({ open, onClose, children, isDismissable = true, contentStyle, contentClassName }) => {
  const handleBackdropClick = useMemo3(() => isDismissable ? onClose : void 0, [onClose, isDismissable]);
  useEffect2(() => {
    if (isDismissable) {
      const handleEscape = (event) => open && event.key === "Escape" && onClose();
      document.addEventListener("keydown", handleEscape);
      return () => document.removeEventListener("keydown", handleEscape);
    }
  }, [open, onClose, isDismissable]);
  const [bodyScrollable, setBodyScrollable] = useState2(true);
  useEffect2(() => {
    setBodyScrollable(getComputedStyle(window.document.body).overflow !== "hidden");
  }, []);
  return /* @__PURE__ */ jsx3(Fragment, { children: open ? createPortal(
    /* @__PURE__ */ jsx3(RemoveScroll, { enabled: bodyScrollable, children: /* @__PURE__ */ jsx3("div", { className: modal_module_default.container, onClick: handleBackdropClick, children: /* @__PURE__ */ jsx3(
      "div",
      {
        className: modal_module_default.modal + (contentClassName ? ` ${contentClassName}` : ""),
        style: contentStyle,
        onClick: stopPropagation,
        children
      }
    ) }) }),
    document.body
  ) : null });
};
var modal_default = Modal;

// esbuild-scss-modules-plugin:./connect.module.scss
var digest4 = "c7bbc091f1227154742a5bd0d55a3df29eb913eb0ad4cafc7ab236b574002f65";
var classes4 = { "connectModal": "_connectModal_1kqtj_1", "title": "_title_1kqtj_4", "closeBtn": "_closeBtn_1kqtj_9", "backBtn": "_backBtn_1kqtj_15", "walletItem": "_walletItem_1kqtj_21", "walletIcon": "_walletIcon_1kqtj_33", "walletName": "_walletName_1kqtj_38", "connecting": "_connecting_1kqtj_43", "connectingIconContainer": "_connectingIconContainer_1kqtj_51", "retryContainer": "_retryContainer_1kqtj_54", "retryIcon": "_retryIcon_1kqtj_63", "connectingIcon": "_connectingIcon_1kqtj_51", "connection": "_connection_1kqtj_72", "acceptRequest": "_acceptRequest_1kqtj_76", "btnDownload": "_btnDownload_1kqtj_83" };
var css4 = `._connectModal_1kqtj_1{gap:12px}._connectModal_1kqtj_1 ._title_1kqtj_4{font-size:18px;font-weight:700;margin-bottom:4px}._connectModal_1kqtj_1 ._closeBtn_1kqtj_9{cursor:pointer;position:absolute;right:16px;top:16px}._connectModal_1kqtj_1 ._backBtn_1kqtj_15{cursor:pointer;left:16px;position:absolute;top:16px}._connectModal_1kqtj_1 ._walletItem_1kqtj_21{border:1px solid #3a3a3a;border-radius:8px;box-sizing:border-box;cursor:pointer;display:flex;padding:8px;width:100%}._connectModal_1kqtj_1 ._walletItem_1kqtj_21:hover{background:hsla(0,0%,100%,.05)}._connectModal_1kqtj_1 ._walletItem_1kqtj_21 ._walletIcon_1kqtj_33{border-radius:4px;height:42px;width:42px}._connectModal_1kqtj_1 ._walletItem_1kqtj_21 ._walletName_1kqtj_38{flex-grow:1;line-height:42px;text-align:center}._connectModal_1kqtj_1 ._connecting_1kqtj_43{align-items:center;display:flex;flex-direction:column;height:204px;justify-content:center;width:100%}._connectModal_1kqtj_1 ._connecting_1kqtj_43 ._connectingIconContainer_1kqtj_51{position:relative}._connectModal_1kqtj_1 ._connecting_1kqtj_43 ._connectingIconContainer_1kqtj_51 ._retryContainer_1kqtj_54{background:#4b5563;border-radius:50%;bottom:-12px;cursor:pointer;padding:4px;position:absolute;right:-12px}._connectModal_1kqtj_1 ._connecting_1kqtj_43 ._connectingIconContainer_1kqtj_51 ._retryContainer_1kqtj_54 ._retryIcon_1kqtj_63{height:24px;width:24px}._connectModal_1kqtj_1 ._connecting_1kqtj_43 ._connectingIcon_1kqtj_51{border-radius:4px;height:60px;width:60px}._connectModal_1kqtj_1 ._connecting_1kqtj_43 ._connection_1kqtj_72{font-size:18px;margin-top:20px}._connectModal_1kqtj_1 ._connecting_1kqtj_43 ._acceptRequest_1kqtj_76{color:hsla(0,0%,100%,.4);font-size:14px;margin-top:6px;text-align:center;white-space:pre-wrap}._connectModal_1kqtj_1 ._connecting_1kqtj_43 ._btnDownload_1kqtj_83{margin-top:20px}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest4)) {
    var ele = document.createElement("style");
    ele.id = digest4;
    ele.textContent = css4;
    document.head.appendChild(ele);
  }
})();
var connect_module_default = classes4;

// src/components/connectModal/index.tsx
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var ConnectModal = ({ open, onClose }) => {
  const [backVisible, setBackVisible] = useState3(false);
  const [retryVisible, setRetryVisible] = useState3(false);
  const [walletReady, setWalletReady] = useState3(true);
  const [selectConnector, setSelectConnector] = useState3();
  const { connect, connectors } = useConnector();
  const closeModal = (accounts) => {
    onClose();
    if (accounts) {
      eventUtils_default.emit("connectResult" /* connectResult */, { result: accounts });
    } else {
      eventUtils_default.emit("connectResult" /* connectResult */, {
        error: {
          code: 4001,
          message: "The user rejected the request."
        }
      });
    }
  };
  useEffect3(() => {
    if (!open) {
      setBackVisible(false);
      setRetryVisible(false);
      setWalletReady(true);
      setSelectConnector(void 0);
    }
  }, [open]);
  const onConnect = (connector) => __async(void 0, null, function* () {
    setBackVisible(true);
    setSelectConnector(connector);
    if (connector.isReady()) {
      try {
        const accounts = yield connect(connector.metadata.id);
        closeModal(accounts);
      } catch (error) {
        if (error.code === 4001) {
          setRetryVisible(true);
        }
      }
    } else {
      setWalletReady(false);
    }
  });
  const onBack = () => {
    setBackVisible(false);
    setRetryVisible(false);
    setWalletReady(true);
    setSelectConnector(void 0);
  };
  const onRetry = () => {
    setRetryVisible(false);
    if (selectConnector) {
      onConnect(selectConnector);
    }
  };
  return /* @__PURE__ */ jsxs2(modal_default, { open, onClose: () => closeModal(), isDismissable: false, contentClassName: connect_module_default.connectModal, children: [
    /* @__PURE__ */ jsx4("div", { className: connect_module_default.title, children: (selectConnector == null ? void 0 : selectConnector.metadata.name) || "Choose Wallet" }),
    /* @__PURE__ */ jsx4("img", { className: connect_module_default.closeBtn, src: close_default, onClick: () => closeModal() }),
    backVisible && /* @__PURE__ */ jsx4("img", { className: connect_module_default.backBtn, src: back_default, onClick: onBack }),
    !backVisible && connectors.map((connector) => {
      return /* @__PURE__ */ jsxs2("div", { className: connect_module_default.walletItem, onClick: () => onConnect(connector), children: [
        /* @__PURE__ */ jsx4("img", { className: connect_module_default.walletIcon, src: connector.metadata.icon }),
        /* @__PURE__ */ jsx4("div", { className: connect_module_default.walletName, children: connector.metadata.name })
      ] }, connector.metadata.id);
    }),
    backVisible && selectConnector && /* @__PURE__ */ jsxs2("div", { className: connect_module_default.connecting, children: [
      /* @__PURE__ */ jsxs2("div", { className: connect_module_default.connectingIconContainer, children: [
        /* @__PURE__ */ jsx4("img", { className: connect_module_default.connectingIcon, src: selectConnector.metadata.icon }),
        retryVisible && /* @__PURE__ */ jsx4("div", { className: connect_module_default.retryContainer, onClick: onRetry, children: /* @__PURE__ */ jsx4("img", { className: connect_module_default.retryIcon, src: retry_default }) })
      ] }),
      walletReady ? /* @__PURE__ */ jsxs2(Fragment2, { children: [
        /* @__PURE__ */ jsx4("div", { className: connect_module_default.connection, children: retryVisible ? "Request Cancelled" : "Requesting Connection" }),
        /* @__PURE__ */ jsx4("div", { className: connect_module_default.acceptRequest, children: retryVisible ? "You cancelled the request.\nClick above to try again." : "Accept the request through your wallet to connect to this app." })
      ] }) : /* @__PURE__ */ jsxs2(Fragment2, { children: [
        /* @__PURE__ */ jsx4("div", { className: connect_module_default.connection, children: "Wallet Not Installed." }),
        /* @__PURE__ */ jsx4(
          button_default,
          {
            className: connect_module_default.btnDownload,
            onClick: () => {
              window.open(selectConnector == null ? void 0 : selectConnector.metadata.downloadUrl, "_blank");
            },
            children: "Get"
          }
        )
      ] })
    ] })
  ] });
};
var connectModal_default = ConnectModal;

// src/components/signModal/index.tsx
import { chains as chains2 } from "@particle-network/chains";
import { useCallback as useCallback6, useEffect as useEffect4, useMemo as useMemo5, useState as useState5 } from "react";
import { formatEther, hexToString } from "viem";

// src/icons/check_box.svg
var check_box_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiNhODU1ZjciPgogICAgPHBhdGgKICAgICAgICBkPSJtNDI0LTMxMiAyODItMjgyLTU2LTU2LTIyNiAyMjYtMTE0LTExNC01NiA1NiAxNzAgMTcwWk0yMDAtMTIwcS0zMyAwLTU2LjUtMjMuNVQxMjAtMjAwdi01NjBxMC0zMyAyMy41LTU2LjVUMjAwLTg0MGg1NjBxMzMgMCA1Ni41IDIzLjVUODQwLTc2MHY1NjBxMCAzMy0yMy41IDU2LjVUNzYwLTEyMEgyMDBabTAtODBoNTYwdi01NjBIMjAwdjU2MFptMC01NjB2NTYwLTU2MFoiIC8+Cjwvc3ZnPg==";

// src/icons/check_box_blank.svg
var check_box_blank_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiM2YjcyODAiPgogICAgPHBhdGgKICAgICAgICBkPSJNMjAwLTEyMHEtMzMgMC01Ni41LTIzLjVUMTIwLTIwMHYtNTYwcTAtMzMgMjMuNS01Ni41VDIwMC04NDBoNTYwcTMzIDAgNTYuNSAyMy41VDg0MC03NjB2NTYwcTAgMzMtMjMuNSA1Ni41VDc2MC0xMjBIMjAwWm0wLTgwaDU2MHYtNTYwSDIwMHY1NjBaIiAvPgo8L3N2Zz4=";

// src/icons/copy.svg
var copy_default = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiNmZmYiPgogICAgPHBhdGgKICAgICAgICBkPSJNMzYwLTI0MHEtMzMgMC01Ni41LTIzLjVUMjgwLTMyMHYtNDgwcTAtMzMgMjMuNS01Ni41VDM2MC04ODBoMzYwcTMzIDAgNTYuNSAyMy41VDgwMC04MDB2NDgwcTAgMzMtMjMuNSA1Ni41VDcyMC0yNDBIMzYwWm0wLTgwaDM2MHYtNDgwSDM2MHY0ODBaTTIwMC04MHEtMzMgMC01Ni41LTIzLjVUMTIwLTE2MHYtNTYwaDgwdjU2MGg0NDB2ODBIMjAwWm0xNjAtMjQwdi00ODAgNDgwWiIgLz4KPC9zdmc+";

// src/utils/index.ts
function shortString(str) {
  if (Array.isArray(str)) {
    str = "[" + str.toString() + "]";
  }
  if (str) {
    if (typeof str.toString === "function") {
      str = str.toString();
    }
    if (str.length <= 10) {
      return str;
    }
    return `${str.slice(0, 5)}...${str.slice(str.length - 5, str.length)}`;
  }
  return "";
}
function copyToClipboard(text) {
  return __async(this, null, function* () {
    const clipboardCopy = () => __async(this, null, function* () {
      if (navigator.clipboard) {
        return navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        const result = document.execCommand("copy");
        document.body.removeChild(textarea);
        if (!result) {
          throw new Error("Copy to clipboard failed");
        }
      }
    });
    return new Promise((resolve, reject) => {
      clipboardCopy().then(resolve).catch(reject);
    });
  });
}
var defaultTokenIcon = "https://static.particle.network/token-list/defaultToken/default.png";
var ipfsToSrc = (ipfs) => {
  if (!ipfs || !ipfs.startsWith("ipfs://")) {
    return ipfs || "";
  }
  return `https://ipfs.particle.network/${encodeURI(ipfs.slice(7))}`;
};
var checkBTCVersion = (accountContracts, accountContractKey, version) => {
  if (!accountContracts[accountContractKey]) {
    return false;
  }
  return accountContracts[accountContractKey].some((item) => item.version === version);
};

// src/utils/ethereumUtils.ts
import { bytesToHex, publicToAddress, toBytes, toChecksumAddress, toRpcSig } from "@ethereumjs/util";
import bitcore from "bitcore-lib";
var pubKeyToEVMAddress = (pubKey) => {
  const address = toChecksumAddress(bytesToHex(publicToAddress(toBytes(`0x${pubKey}`), true)));
  return address;
};
var convertSignature = (signature) => {
  const sig = bitcore.crypto.Signature.fromCompact(Buffer.from(signature, "base64"));
  const v = BigInt(sig.i + 27);
  const evmSig = toRpcSig(v, sig.r.toBuffer(), sig.s.toBuffer());
  return evmSig;
};
function caculateNativeFee(userOp) {
  return (BigInt(userOp.callGasLimit) + BigInt(userOp.verificationGasLimit) + BigInt(userOp.preVerificationGas)) * BigInt(userOp.maxFeePerGas);
}
var getBTCAAAddress = (smartAccount, btcAddress, name, version) => __async(void 0, null, function* () {
  var _a;
  const addresses = yield smartAccount.provider.request({ method: "eth_accounts" });
  const owner = addresses[0];
  const localKey = `particle_${name}_${version}_${owner}`;
  if (typeof window !== "undefined" && localStorage) {
    const localAA = localStorage.getItem(localKey);
    if (localAA) {
      return localAA;
    }
  }
  const btcPublicKey = yield smartAccount.provider.getPublicKey();
  const accountInfo = yield smartAccount.sendRpc({
    method: "particle_aa_getBTCAccount",
    params: [
      {
        name,
        version,
        btcPublicKey,
        btcAddress
      }
    ]
  });
  const address = (_a = accountInfo == null ? void 0 : accountInfo[0]) == null ? void 0 : _a.smartAccountAddress;
  if (typeof window !== "undefined" && localStorage && address) {
    localStorage.setItem(localKey, address);
  }
  return address;
});
var getBTCAccountInfo = (smartAccount, btcAddress, name, version) => __async(void 0, null, function* () {
  const btcPublicKey = yield smartAccount.provider.getPublicKey();
  const [accountInfo] = yield smartAccount.sendRpc({
    method: "particle_aa_getBTCAccount",
    params: [
      {
        name,
        version,
        btcPublicKey,
        btcAddress
      }
    ]
  });
  const address = accountInfo.smartAccountAddress;
  const addresses = yield smartAccount.provider.request({ method: "eth_accounts" });
  const owner = addresses[0];
  const localKey = `particle_${name}_${version}_${owner}`;
  if (typeof window !== "undefined" && localStorage && address) {
    localStorage.setItem(localKey, address);
  }
  return accountInfo;
});

// src/components/copyText/index.tsx
import { useState as useState4 } from "react";

// esbuild-scss-modules-plugin:./copyText.module.scss
var digest5 = "d6fbb5df7ed6ec51d41f665ca768306181bb1e7d7c1cef8eed9bd4230368d7bb";
var classes5 = { "copyText": "_copyText_smolu_1", "copied": "_copied_smolu_9" };
var css5 = `._copyText_smolu_1{cursor:pointer;text-decoration-line:underline}._copyText_smolu_1:hover{opacity:.75}._copied_smolu_9{color:#a855f7;cursor:none;text-decoration-line:none}._copied_smolu_9:hover{opacity:1}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest5)) {
    var ele = document.createElement("style");
    ele.id = digest5;
    ele.textContent = css5;
    document.head.appendChild(ele);
  }
})();
var copyText_module_default = classes5;

// src/components/copyText/index.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
function CopyText({ children, value, className, style }) {
  const [copied, setCopied] = useState4();
  const handleClick = () => __async(this, null, function* () {
    if (copied) {
      return;
    }
    try {
      if (value) {
        yield copyToClipboard(value);
      } else if (typeof children === "string" || typeof children === "number" || typeof children === "boolean") {
        yield copyToClipboard(children.toString());
      } else {
        throw new Error("please set copy value");
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1e3);
    } catch (error) {
    }
  });
  return /* @__PURE__ */ jsx5(
    "div",
    {
      className: copyText_module_default.copyText + (className ? ` ${className}` : "") + (copied ? ` ${copyText_module_default.copied}` : ""),
      onClick: handleClick,
      style,
      children: copied ? "Copied" : children
    }
  );
}

// src/components/transactionDetails/index.tsx
import { chains } from "@particle-network/chains";
import { useCallback as useCallback5, useMemo as useMemo4 } from "react";
import { formatUnits } from "viem";

// src/icons/unverified.svg
var unverified_default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB0PSIxNzA5Mjg0MDMwNzM5IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDExNTIgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICBwLWlkPSIxMzY3NSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KICAgIDxwYXRoCiAgICAgICAgZD0iTTExMjguNjQgODA2LjI3Mkw2NzYuMTYgNzIuMzJjLTU1LjE2OC05Ni4zMi0xNDUuMTUyLTk2LjMyLTIwMC4yNTYgMEwyMy4yMzIgODA2LjRDLTMxLjgwOCA5MDIuNTkyIDE0LjU5MiA5NzkuMiAxMjQuOCA5NzkuMmg5MDUuMjE2YzEwNy4zOTIgMCAxNTMuNzkyLTc5LjM2IDk4LjYyNC0xNzIuOTI4eiIKICAgICAgICBmaWxsPSIjZWFiMzA4IiBwLWlkPSIxMzY3NiI+PC9wYXRoPgogICAgPHBhdGgKICAgICAgICBkPSJNNTc0LjQ2NCA2OTUuODA4YzMyIDAgNjAuOTkyIDI4LjM1MiA2MC45OTIgNTkuNTIgMCAzMS4xNjgtMjYuMTEyIDU5LjUyLTYwLjk5MiA1OS41MmE2MC41NDQgNjAuNTQ0IDAgMCAxLTYwLjgtNTkuNTJjMC0zMS4yMzIgMjguOTI4LTU5LjUyIDYwLjgtNTkuNTJ6IG0yLjg4LTQ0NC45OTJjMjMuMjk2IDAgNDMuNTg0IDE5Ljg0IDQzLjU4NCA0Mi40OTZ2Mjk3LjZjMCAyMi42NTYtMjAuMjg4IDQyLjQ5Ni00My41MiA0Mi40OTZhNDQuMTYgNDQuMTYgMCAwIDEtNDMuNTItNDIuNDk2di0yOTcuNmMwLTIyLjY1NiAyMC4yODgtNDIuNDk2IDQzLjUyLTQyLjQ5NnoiCiAgICAgICAgZmlsbD0iI0ZGRkZGRiIgcC1pZD0iMTM2NzciPjwvcGF0aD4KPC9zdmc+";

// src/icons/verified.svg
var verified_default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB0PSIxNzA5MjgzOTE4NzM0IiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICBwLWlkPSIxMjI3OCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KICAgIDxwYXRoIGQ9Ik01MTIgNTEybS01MTIgMGE1MTIgNTEyIDAgMSAwIDEwMjQgMCA1MTIgNTEyIDAgMSAwLTEwMjQgMFoiIGZpbGw9IiM0YWRlODAiIHAtaWQ9IjEyMjc5Ij48L3BhdGg+CiAgICA8cGF0aAogICAgICAgIGQ9Ik00NjkuMzc2IDYyMC4xNkwyOTMuNjMyIDQ2OC40OEE1Ny42IDU3LjYgMCAxIDAgMjE4LjM2OCA1NTUuNTJsMjE5LjcxMiAxODkuNzZhNjAuOCA2MC44IDAgMCAwIDg1Ljc2LTYuMjcybDIuNDk2LTMuMTM2IDI4Ny42MTYtMzgxLjI0OGE1Ny42IDU3LjYgMCAwIDAtOTEuOTA0LTY5LjM3Nkw0NjkuMzc2IDYyMC4xNnoiCiAgICAgICAgZmlsbD0iI0ZGRkZGRiIgcC1pZD0iMTIyODAiPjwvcGF0aD4KPC9zdmc+";

// esbuild-scss-modules-plugin:./tooltip.module.scss
var digest6 = "ee15dc27fcfd209601159e7f0e0063ff4e7a886b7b892c1600a911372b82a0b1";
var classes6 = { "tipContainer": "_tipContainer_ufud7_1", "tipContent": "_tipContent_ufud7_5" };
var css6 = `._tipContainer_ufud7_1{overflow:visible;position:relative}._tipContainer_ufud7_1 ._tipContent_ufud7_5{background:#3f3f46;border-radius:8px;bottom:100%;color:#fff;font-size:11px;left:-100%;opacity:0;padding:3px 6px;position:absolute;transition:opacity .5s;visibility:hidden;white-space:nowrap;z-index:1}._tipContainer_ufud7_1:hover ._tipContent_ufud7_5{opacity:1;visibility:visible}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest6)) {
    var ele = document.createElement("style");
    ele.id = digest6;
    ele.textContent = css6;
    document.head.appendChild(ele);
  }
})();
var tooltip_module_default = classes6;

// src/components/tooltip/index.tsx
import { jsx as jsx6, jsxs as jsxs3 } from "react/jsx-runtime";
var Tooltip = ({ children, content, className }) => {
  return /* @__PURE__ */ jsxs3("div", { className: tooltip_module_default.tipContainer, children: [
    children,
    /* @__PURE__ */ jsx6("div", { className: tooltip_module_default.tipContent + (className ? ` ${className}` : ""), children: content })
  ] });
};
var tooltip_default = Tooltip;

// esbuild-scss-modules-plugin:./transactionDetails.module.scss
var digest7 = "a81c744751497ed4b401c08b9e5aeef1991aeb86f2cbba3ee57c1926c0502f1a";
var classes7 = { "detailsCard": "_detailsCard_ml2p9_1", "title": "_title_ml2p9_13", "nftContract": "_nftContract_ml2p9_19", "row": "_row_ml2p9_26", "tokenIcon": "_tokenIcon_ml2p9_35", "nftIcon": "_nftIcon_ml2p9_41", "balanceChange": "_balanceChange_ml2p9_49", "tokenSymbol": "_tokenSymbol_ml2p9_56", "toContract": "_toContract_ml2p9_61", "right": "_right_ml2p9_71" };
var css7 = `._detailsCard_ml2p9_1{background:#232529;border:1px solid #252525;border-radius:8px;color:#fff;margin-top:16px;overflow-x:hidden;padding:10px;position:relative;width:100%}._detailsCard_ml2p9_1 ._title_ml2p9_13{font-size:16px;font-weight:600;margin-bottom:12px;text-align:left}._detailsCard_ml2p9_1 ._nftContract_ml2p9_19{color:#a855f7;font-size:16px;position:absolute;right:8px;top:8px}._detailsCard_ml2p9_1 ._row_ml2p9_26{align-items:center;display:flex;flex-direction:row;font-size:14px;gap:8px;justify-content:space-between;margin-top:6px}._detailsCard_ml2p9_1 ._row_ml2p9_26 ._tokenIcon_ml2p9_35{border-radius:50%;height:32px;margin:10px 0;width:32px}._detailsCard_ml2p9_1 ._row_ml2p9_26 ._nftIcon_ml2p9_41{border-radius:2px;display:inline;height:32px;margin:10px 8px 10px 0;width:32px}._detailsCard_ml2p9_1 ._row_ml2p9_26 ._balanceChange_ml2p9_49{flex-grow:2;font-size:16px;font-weight:500;text-align:end;word-break:break-word}._detailsCard_ml2p9_1 ._row_ml2p9_26 ._tokenSymbol_ml2p9_56{font-size:16px;font-weight:500;text-align:end}._detailsCard_ml2p9_1 ._row_ml2p9_26 ._toContract_ml2p9_61{align-items:center;display:flex;gap:8px}._detailsCard_ml2p9_1 ._row_ml2p9_26 ._toContract_ml2p9_61 img{display:inline;height:18px;width:18px}._detailsCard_ml2p9_1 ._row_ml2p9_26 ._right_ml2p9_71{text-align:end}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest7)) {
    var ele = document.createElement("style");
    ele.id = digest7;
    ele.textContent = css7;
    document.head.appendChild(ele);
  }
})();
var transactionDetails_module_default = classes7;

// src/components/transactionDetails/index.tsx
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var TransactionDetails = ({ details }) => {
  const { chainId } = useETHProvider();
  const chainInfo = useMemo4(() => {
    if (chainId) {
      return chains.getEVMChainInfoById(chainId);
    }
  }, [chainId]);
  const titleContent = useMemo4(() => {
    var _a;
    switch (details.type) {
      case "native_transfer" /* NATIVE_TRANSFER */:
        return `Send ${chainInfo == null ? void 0 : chainInfo.nativeCurrency.symbol}`;
      case "erc20_transfer" /* ERC20_TRANSFER */:
        return `Send ${(_a = details.estimatedChanges.tokens[0]) == null ? void 0 : _a.symbol}`;
      case "erc20_approve" /* ERC20_APPROVE */:
        return "Approve Spending";
      case "erc721_transfer" /* ERC721_TRANFER */:
        return "Send NFT";
      case "erc1155_transfer" /* ERC1155_TRANFER */:
        return "Send NFT";
      default:
        return "Transaction Details";
    }
  }, [details, chainInfo]);
  const nftContractType = useMemo4(() => {
    if (details.type === "erc721_transfer" /* ERC721_TRANFER */) {
      return "ERC721";
    } else if (details.type === "erc1155_transfer" /* ERC1155_TRANFER */) {
      return "ERC1155";
    }
  }, [details]);
  const nativeIcon = useMemo4(() => {
    if (chainInfo) {
      if (chainInfo.nativeCurrency.symbol === "ETH") {
        return "https://static.particle.network/token-list/ethereum/native.png";
      } else {
        return chainInfo.nativeIcon || chainInfo.icon;
      }
    }
    return defaultTokenIcon;
  }, [chainInfo]);
  const to = useMemo4(() => {
    var _a, _b;
    const params = (_b = (_a = details.data) == null ? void 0 : _a.function) == null ? void 0 : _b.params;
    if (details.type == "erc20_transfer" /* ERC20_TRANSFER */) {
      return params ? params[params.length === 3 ? 1 : 0].value : "";
    } else if (details.type == "erc20_approve" /* ERC20_APPROVE */) {
      return params ? params[0].value : "";
    } else if (details.type == "native_transfer" /* NATIVE_TRANSFER */) {
      return details.data.to;
    } else if (details.type == "erc721_transfer" /* ERC721_TRANFER */ || details.type == "erc1155_transfer" /* ERC1155_TRANFER */) {
      return params ? params[1].value : "";
    } else {
      return details.data.to;
    }
  }, [details]);
  const balanceChangeTextColor = useCallback5((value) => {
    if (BigInt(value) > 0) {
      return "#4ade80";
    } else if (BigInt(value) < 0) {
      return "#ef4444";
    } else {
      return "white";
    }
  }, []);
  const functionContent = useMemo4(() => {
    if (details.type !== "native_transfer" /* NATIVE_TRANSFER */ && details.data.function) {
      const params = details.data.function.params.map((item) => item.name);
      return `${details.data.function.name}(${params.join(", ")})`;
    }
  }, [details]);
  const approveTokenAmount = useMemo4(() => {
    var _a, _b, _c, _d;
    if (details.type === "erc20_approve" /* ERC20_APPROVE */) {
      const amount = (_d = (_c = (_b = (_a = details.data) == null ? void 0 : _a.function) == null ? void 0 : _b.params) == null ? void 0 : _c[1]) == null ? void 0 : _d.value;
      return BigInt(amount || 0);
    }
    return BigInt(0);
  }, [details]);
  const tokenAmountChange = useCallback5(
    (tokenItem) => {
      const result = formatUnits(
        details.type === "erc20_approve" /* ERC20_APPROVE */ ? approveTokenAmount : BigInt(tokenItem.amountChange),
        tokenItem.decimals
      );
      if (details.type !== "erc20_approve" /* ERC20_APPROVE */ && BigInt(tokenItem.amountChange) > BigInt(0)) {
        return `+${result}`;
      }
      return result;
    },
    [approveTokenAmount, details]
  );
  const showContactAddress = useMemo4(() => {
    return details.type === "erc20_transfer" /* ERC20_TRANSFER */ || details.type === "erc20_approve" /* ERC20_APPROVE */ || details.type === "erc721_transfer" /* ERC721_TRANFER */ || details.type === "erc1155_transfer" /* ERC1155_TRANFER */;
  }, [details]);
  return /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.detailsCard, children: [
    /* @__PURE__ */ jsx7("div", { className: transactionDetails_module_default.title, children: titleContent }),
    nftContractType && /* @__PURE__ */ jsx7("div", { className: transactionDetails_module_default.nftContract, children: nftContractType }),
    details.estimatedChanges.natives.map((nativeItem) => {
      return /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.row, children: [
        /* @__PURE__ */ jsx7("img", { className: transactionDetails_module_default.tokenIcon, src: nativeIcon }),
        /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.balanceChange, style: { color: balanceChangeTextColor(nativeItem.nativeChange) }, children: [
          BigInt(nativeItem.nativeChange) > 0 ? "+" : void 0,
          formatUnits(BigInt(nativeItem.nativeChange), (chainInfo == null ? void 0 : chainInfo.nativeCurrency.decimals) || 18)
        ] }),
        /* @__PURE__ */ jsx7("div", { className: transactionDetails_module_default.tokenSymbol, children: chainInfo == null ? void 0 : chainInfo.nativeCurrency.symbol })
      ] }, nativeItem.address);
    }),
    details.estimatedChanges.tokens.map((tokenItem) => {
      return /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.row, children: [
        /* @__PURE__ */ jsx7("img", { className: transactionDetails_module_default.tokenIcon, src: tokenItem.image || defaultTokenIcon }),
        /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.balanceChange, children: [
          /* @__PURE__ */ jsx7("span", { style: { color: balanceChangeTextColor(tokenItem.amountChange) }, children: tokenAmountChange(tokenItem) }),
          ` ${tokenItem.symbol}`
        ] })
      ] }, tokenItem.address);
    }),
    details.estimatedChanges.nfts.map((nftItem) => {
      return /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.row, children: [
        /* @__PURE__ */ jsxs4("div", { style: { fontSize: 16 }, children: [
          /* @__PURE__ */ jsx7("img", { className: transactionDetails_module_default.nftIcon, src: ipfsToSrc(nftItem.image || defaultTokenIcon) }),
          nftItem.name || `NFT#${nftItem.tokenId}`
        ] }),
        /* @__PURE__ */ jsx7("div", { className: transactionDetails_module_default.balanceChange, style: { color: balanceChangeTextColor(nftItem.amountChange) }, children: nftItem.amountChange })
      ] }, nftItem.address);
    }),
    to && /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.row, children: [
      /* @__PURE__ */ jsx7("div", { children: "To" }),
      /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.toContract, children: [
        details.toVerified != null && !showContactAddress && /* @__PURE__ */ jsx7(tooltip_default, { content: details.toVerified ? "Verified Contract" : "Unverified Contract", children: /* @__PURE__ */ jsx7("img", { src: details.toVerified ? verified_default : unverified_default }) }),
        /* @__PURE__ */ jsx7(CopyText, { value: to, children: shortString(to) })
      ] })
    ] }),
    showContactAddress && /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.row, children: [
      /* @__PURE__ */ jsx7("div", { children: "Contract" }),
      /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.toContract, children: [
        details.toVerified != null && /* @__PURE__ */ jsx7(tooltip_default, { content: details.toVerified ? "Verified Contract" : "Unverified Contract", children: /* @__PURE__ */ jsx7("img", { src: details.toVerified ? verified_default : unverified_default }) }),
        /* @__PURE__ */ jsx7(CopyText, { value: details.data.to, children: shortString(details.data.to) })
      ] })
    ] }),
    /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.row, children: [
      /* @__PURE__ */ jsx7("div", { children: "Hex Data" }),
      /* @__PURE__ */ jsx7(CopyText, { value: details.data.data, children: shortString(details.data.data) })
    ] }),
    functionContent && /* @__PURE__ */ jsxs4("div", { className: transactionDetails_module_default.row, children: [
      /* @__PURE__ */ jsx7("div", { children: "Function" }),
      /* @__PURE__ */ jsx7("div", { className: transactionDetails_module_default.right, children: functionContent })
    ] })
  ] });
};
var transactionDetails_default = TransactionDetails;

// esbuild-scss-modules-plugin:./sign.module.scss
var digest8 = "3ab1a455562ae7e24c2ac49572897e615b9e9275066fd0d64f0cf24844521bab";
var classes8 = { "modalContent": "_modalContent_aoysu_1", "closeBtn": "_closeBtn_aoysu_5", "signTitle": "_signTitle_aoysu_11", "chainInfo": "_chainInfo_aoysu_16", "addressContainer": "_addressContainer_aoysu_29", "addressInfo": "_addressInfo_aoysu_34", "detailsContent": "_detailsContent_aoysu_49", "fill": "_fill_aoysu_58", "unsignedMessage": "_unsignedMessage_aoysu_61", "estimatedGas": "_estimatedGas_aoysu_76", "signBtn": "_signBtn_aoysu_81", "notRemind": "_notRemind_aoysu_85" };
var css8 = `._modalContent_aoysu_1{color:#fff;text-align:center}._modalContent_aoysu_1 ._closeBtn_aoysu_5{cursor:pointer;position:absolute;right:16px;top:16px}._modalContent_aoysu_1 ._signTitle_aoysu_11{font-size:20px;font-weight:600;margin-bottom:10px}._modalContent_aoysu_1 ._chainInfo_aoysu_16{align-items:center;display:flex;flex-direction:row;font-size:12px;gap:8px;justify-content:center;margin-bottom:8px}._modalContent_aoysu_1 ._chainInfo_aoysu_16 img{height:18px;width:18px}._modalContent_aoysu_1 ._addressContainer_aoysu_29{height:28px;margin-bottom:16px;margin-top:8px}._modalContent_aoysu_1 ._addressContainer_aoysu_29 ._addressInfo_aoysu_34{align-items:center;background:rgba(58,58,58,.635);border-radius:20px;display:flex;flex-direction:row;font-size:12px;gap:4px;justify-content:center;padding:4px 8px}._modalContent_aoysu_1 ._addressContainer_aoysu_29 ._addressInfo_aoysu_34 img{height:18px;width:18px}._modalContent_aoysu_1 ._detailsContent_aoysu_49{max-height:0;overflow-y:auto;transition:max-height .3s linear;width:100%}._modalContent_aoysu_1 ._detailsContent_aoysu_49::-webkit-scrollbar{display:none}._modalContent_aoysu_1 ._detailsContent_aoysu_49._fill_aoysu_58{max-height:500px}._modalContent_aoysu_1 ._detailsContent_aoysu_49 ._unsignedMessage_aoysu_61{background:#232529;border:1px solid #252525;border-radius:8px;box-sizing:border-box;color:#fff;font-size:14px;padding:8px;width:100%;word-wrap:break-word;color:hsla(0,0%,100%,.631);text-align:left;white-space:pre-wrap}._modalContent_aoysu_1 ._estimatedGas_aoysu_76{color:hsla(0,0%,100%,.631);font-size:12px;margin-top:24px}._modalContent_aoysu_1 ._signBtn_aoysu_81{margin-top:24px;min-width:200px}._modalContent_aoysu_1 ._notRemind_aoysu_85{align-items:center;color:hsla(0,0%,100%,.631);cursor:pointer;display:inline-flex;font-size:12px;gap:4px;margin-top:16px}._modalContent_aoysu_1 ._notRemind_aoysu_85:hover{opacity:.85}`;
(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest8)) {
    var ele = document.createElement("style");
    ele.id = digest8;
    ele.textContent = css8;
    document.head.appendChild(ele);
  }
})();
var sign_module_default = classes8;

// src/components/signModal/index.tsx
import { Fragment as Fragment3, jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var SignModal = ({ open, onClose, onOpen }) => {
  const [userOpBundle, setUserOpBundle] = useState5();
  const [notRemindChecked, setNotRemindChecked] = useState5(false);
  const [loading, setLoading] = useState5(false);
  const [deserializeLoading, setDeserializeLoading] = useState5(false);
  const [deserializeResult, setDeserializeResult] = useState5();
  const [disabled, setDisabled] = useState5(false);
  const [showNotRemind, setShowNotRemind] = useState5(true);
  const [nativeBalance, setNativeBalance] = useState5();
  const { accountContract } = useAccountContract();
  const [requestArguments, setRequestArguments] = useState5();
  const { chainId, publicClient, evmAccount, provider } = useETHProvider();
  const { smartAccount } = useConnectProvider();
  useEffect4(() => {
    if (!open) {
      setDeserializeResult(void 0);
      setUserOpBundle(void 0);
      setRequestArguments(void 0);
      setLoading(false);
      setDisabled(false);
      setDeserializeLoading(false);
      setNativeBalance(void 0);
    }
  }, [open]);
  useEffect4(() => {
    if (open) {
      const notRemind = txConfirmUtils_default.isNotRemind();
      setShowNotRemind(!notRemind);
      if (!notRemind) {
        setNotRemindChecked(false);
      }
    }
  }, [open]);
  const chainInfo = useMemo5(() => {
    if (chainId) {
      return chains2.getEVMChainInfoById(chainId);
    }
  }, [chainId]);
  useEffect4(() => {
    const onSendUserOp = (opBundle) => {
      setUserOpBundle(opBundle);
      onOpen();
    };
    const onPersonalSign = (arg) => {
      setRequestArguments(arg);
      onOpen();
    };
    const onSignTypedData = (arg) => {
      setRequestArguments(arg);
      onOpen();
    };
    eventUtils_default.on("sendUserOp" /* sendUserOp */, onSendUserOp);
    eventUtils_default.on("personalSign" /* personalSign */, onPersonalSign);
    eventUtils_default.on("signTypedData" /* signTypedData */, onSignTypedData);
    return () => {
      eventUtils_default.off("sendUserOp" /* sendUserOp */, onSendUserOp);
      eventUtils_default.off("personalSign" /* personalSign */, onPersonalSign);
      eventUtils_default.off("signTypedData" /* signTypedData */, onSignTypedData);
    };
  }, [onOpen, setUserOpBundle]);
  const deserializeUserOp = useCallback6(() => __async(void 0, null, function* () {
    if (userOpBundle && smartAccount) {
      const addresses = yield smartAccount.provider.request({ method: "eth_accounts" });
      const owner = addresses[0];
      const result = yield smartAccount.sendRpc({
        method: "particle_aa_deserializeUserOp",
        params: [
          {
            name: accountContract.name,
            version: accountContract.version,
            ownerAddress: owner
          },
          userOpBundle.userOp
        ]
      });
      return result;
    }
  }), [userOpBundle, smartAccount, accountContract]);
  useEffect4(() => {
    if (userOpBundle && open) {
      setDeserializeLoading(true);
      deserializeUserOp().then((result) => {
        setDeserializeResult(result);
      }).catch((error) => {
        eventUtils_default.emit("sendUserOpResult" /* sendUserOpResult */, {
          error
        });
        onClose();
      });
    }
  }, [deserializeUserOp, userOpBundle, open, onClose]);
  useEffect4(() => {
    if (open && publicClient && evmAccount && userOpBundle) {
      publicClient.getBalance({ address: evmAccount }).then((result) => setNativeBalance(result)).catch((error) => {
        eventUtils_default.emit("sendUserOpResult" /* sendUserOpResult */, {
          error
        });
        onClose();
      });
    }
  }, [open, publicClient, evmAccount, userOpBundle, onClose]);
  useEffect4(() => {
    if (nativeBalance != null && deserializeResult != null) {
      setDeserializeLoading(false);
    }
  }, [nativeBalance, deserializeResult]);
  const toggleNotRemind = () => {
    setNotRemindChecked(!notRemindChecked);
    txConfirmUtils_default.setNotRemind(!notRemindChecked);
  };
  const gasFee = useMemo5(() => {
    if (userOpBundle == null ? void 0 : userOpBundle.userOp) {
      return caculateNativeFee(userOpBundle == null ? void 0 : userOpBundle.userOp);
    }
    return BigInt(0);
  }, [userOpBundle]);
  const closeModal = () => {
    var _a;
    let event;
    if (userOpBundle) {
      event = "sendUserOpResult" /* sendUserOpResult */;
    } else if ((requestArguments == null ? void 0 : requestArguments.method) === "personal_sign" /* personalSign */) {
      event = "personalSignResult" /* personalSignResult */;
    } else if ((_a = requestArguments == null ? void 0 : requestArguments.method) == null ? void 0 : _a.startsWith("eth_signTypedData" /* signTypedData */)) {
      event = "signTypedDataResult" /* signTypedDataResult */;
    }
    if (event) {
      eventUtils_default.emit(event, {
        error: {
          code: 4001,
          message: "The user rejected the request."
        }
      });
    }
    onClose();
  };
  const confirmTx = useCallback6(() => __async(void 0, null, function* () {
    if (smartAccount && provider) {
      setLoading(true);
      if (userOpBundle) {
        try {
          const hash = yield smartAccount.sendUserOperation(userOpBundle);
          eventUtils_default.emit("sendUserOpResult" /* sendUserOpResult */, { result: hash });
        } catch (error) {
          eventUtils_default.emit("sendUserOpResult" /* sendUserOpResult */, {
            error
          });
        } finally {
          setLoading(false);
        }
      } else if (requestArguments) {
        try {
          const hash = yield provider.request(requestArguments);
          eventUtils_default.emit(
            requestArguments.method == "personal_sign" /* personalSign */ ? "personalSignResult" /* personalSignResult */ : "signTypedDataResult" /* signTypedDataResult */,
            { result: hash }
          );
        } catch (error) {
          eventUtils_default.emit(
            requestArguments.method == "personal_sign" /* personalSign */ ? "personalSignResult" /* personalSignResult */ : "signTypedDataResult" /* signTypedDataResult */,
            {
              error
            }
          );
        } finally {
          setLoading(false);
        }
      }
      onClose();
    }
  }), [smartAccount, provider, requestArguments, userOpBundle, onClose]);
  useEffect4(() => {
    if (userOpBundle && nativeBalance != null && deserializeResult) {
      const nativeChange = deserializeResult.filter(
        (item) => {
          var _a, _b;
          return ((_b = (_a = item.estimatedChanges.natives) == null ? void 0 : _a[0]) == null ? void 0 : _b.nativeChange) && item.estimatedChanges.natives[0].nativeChange.startsWith("-");
        }
      ).map((item) => {
        var _a, _b, _c, _d;
        return BigInt(((_d = (_c = (_b = (_a = item.estimatedChanges) == null ? void 0 : _a.natives) == null ? void 0 : _b[0]) == null ? void 0 : _c.nativeChange) == null ? void 0 : _d.replace("-", "")) || 0);
      }).reduce((accumulator, currentValue) => accumulator + currentValue, BigInt(0));
      if (userOpBundle.userOp.paymasterAndData.length > 2) {
        setDisabled(nativeBalance < nativeChange);
      } else {
        setDisabled(nativeBalance < gasFee + nativeChange);
      }
    }
  }, [userOpBundle, gasFee, nativeBalance, deserializeResult]);
  const unsignedMessage = useMemo5(() => {
    var _a, _b;
    if (!requestArguments) {
      return void 0;
    }
    if (requestArguments.method === "personal_sign" /* personalSign */) {
      const message = ((_a = requestArguments.params) == null ? void 0 : _a[0]) || "0x";
      return hexToString(message);
    } else {
      const typedData = (_b = requestArguments.params) == null ? void 0 : _b[1];
      const obj = typeof typedData === "string" ? JSON.parse(typedData) : typedData;
      return JSON.stringify(obj, null, 2);
    }
  }, [requestArguments]);
  return /* @__PURE__ */ jsx8(modal_default, { open, onClose, isDismissable: false, contentClassName: sign_module_default.modalContent, children: /* @__PURE__ */ jsxs5(Fragment3, { children: [
    /* @__PURE__ */ jsx8("img", { className: sign_module_default.closeBtn, src: close_default, onClick: closeModal }),
    requestArguments && /* @__PURE__ */ jsx8("div", { className: sign_module_default.signTitle, children: requestArguments.method == "personal_sign" /* personalSign */ ? "Sign Message" : "Sign Typed Data" }),
    /* @__PURE__ */ jsxs5("div", { className: sign_module_default.chainInfo, children: [
      /* @__PURE__ */ jsx8("img", { src: chainInfo == null ? void 0 : chainInfo.icon }),
      chainInfo == null ? void 0 : chainInfo.fullname.replace("Mainnet", "")
    ] }),
    /* @__PURE__ */ jsx8("div", { className: sign_module_default.addressContainer, children: /* @__PURE__ */ jsx8(CopyText, { value: evmAccount, style: { textDecorationLine: "none" }, children: /* @__PURE__ */ jsxs5("div", { className: sign_module_default.addressInfo, children: [
      shortString(evmAccount),
      /* @__PURE__ */ jsx8("img", { src: copy_default })
    ] }) }) }),
    /* @__PURE__ */ jsxs5("div", { className: sign_module_default.detailsContent + (deserializeResult || requestArguments ? ` ${sign_module_default.fill}` : ""), children: [
      deserializeResult && deserializeResult.map((details, index) => /* @__PURE__ */ jsx8(transactionDetails_default, { details }, `${details.type}-${index}`)),
      unsignedMessage && /* @__PURE__ */ jsx8("div", { className: sign_module_default.unsignedMessage, children: unsignedMessage })
    ] }),
    gasFee && /* @__PURE__ */ jsx8("div", { className: sign_module_default.estimatedGas, children: `Estimated gas fee: ${formatEther(gasFee)} ${chainInfo == null ? void 0 : chainInfo.nativeCurrency.symbol}` }),
    /* @__PURE__ */ jsx8(
      button_default,
      {
        onClick: confirmTx,
        className: sign_module_default.signBtn,
        isLoading: loading || deserializeLoading,
        isDisabled: disabled,
        children: deserializeLoading ? "LOADING" : disabled ? "INSUFFICIENT FEE" : "CONFIRM"
      }
    ),
    showNotRemind && /* @__PURE__ */ jsxs5("div", { className: sign_module_default.notRemind, onClick: toggleNotRemind, children: [
      /* @__PURE__ */ jsx8("img", { src: notRemindChecked ? check_box_default : check_box_blank_default }),
      "Do not remind me again"
    ] })
  ] }) });
};
var signModal_default = SignModal;

// src/evmSigner/index.ts
import { intToHex as intToHex2 } from "@ethereumjs/util";
import { chains as chains3 } from "@particle-network/chains";
import { EventEmitter as EventEmitter3 } from "events";
import {
  InvalidParamsRpcError,
  SwitchChainError,
  UnsupportedProviderMethodError,
  createPublicClient,
  hashMessage,
  hashTypedData,
  http
} from "viem";
var AASignerProvider = class {
  constructor(supportChainIds, projectId, clientKey, rpcUrls) {
    this.supportChainIds = supportChainIds;
    this.projectId = projectId;
    this.clientKey = clientKey;
    this.rpcUrls = rpcUrls;
    this.chainId = 1;
    this.personalSign = (message) => __async(this, null, function* () {
      throw new Error("Wallet not connected!");
    });
    this.getPublicKey = () => __async(this, null, function* () {
      throw new Error("Wallet not connected!");
    });
    this.getPublicClient = () => {
      var _a, _b;
      const rpcUrl = ((_a = this == null ? void 0 : this.rpcUrls) == null ? void 0 : _a[this.chainId]) || ((_b = chains3.getEVMChainInfoById(this.chainId || 1)) == null ? void 0 : _b.rpcUrl);
      return createPublicClient({
        transport: http(rpcUrl)
      });
    };
    this.events = new EventEmitter3();
    this.events.setMaxListeners(100);
    if (typeof window !== "undefined") {
      const localChainId = localStorage.getItem("connect-evm-chain-id");
      if (localChainId && supportChainIds.includes(Number(localChainId))) {
        this.chainId = Number(localChainId);
      } else {
        const chainId = supportChainIds[0];
        if (chainId) {
          localStorage.setItem("connect-evm-chain-id", chainId.toString());
          this.chainId = chainId;
        }
      }
    }
    this.publicClient = this.getPublicClient();
  }
  request(arg) {
    return __async(this, null, function* () {
      var _a, _b;
      if (arg.method === "eth_sendTransaction" || arg.method === "wallet_addEthereumChain" || arg.method === "wallet_watchAsset" || arg.method === "eth_sign") {
        throw new UnsupportedProviderMethodError(new Error("The Provider does not support the requested method."));
      }
      if (arg.method === "eth_accounts" || arg.method === "eth_requestAccounts") {
        const pubKey = yield this.getPublicKey();
        const address = pubKeyToEVMAddress(pubKey);
        return [address];
      } else if (arg.method === "eth_chainId") {
        return `0x${this.chainId.toString(16)}`;
      } else if (arg.method === "personal_sign" /* personalSign */) {
        let message = (_a = arg.params) == null ? void 0 : _a[0];
        if (message.length !== 66) {
          const hash = hashMessage({ raw: message });
          message = hash;
        }
        const result = yield this.personalSign(message || "");
        const convertResult = convertSignature(result);
        if (!convertResult) {
          throw new Error("sign error");
        }
        return convertResult;
      } else if (arg.method === "eth_signTypedData" || arg.method === "eth_signTypedData_v4") {
        const typedData = (_b = arg.params) == null ? void 0 : _b[1];
        const hash = hashTypedData(typeof typedData === "string" ? JSON.parse(typedData) : typedData);
        const result = yield this.personalSign(hash || "");
        const convertResult = convertSignature(result);
        if (!convertResult) {
          throw new Error("sign error");
        }
        return convertResult;
      } else if (arg.method === "wallet_switchEthereumChain") {
        if (arg.params && arg.params instanceof Array && arg.params[0] && arg.params[0].chainId) {
          const chainId = Number(arg.params[0].chainId);
          if (this.supportChainIds.includes(this.chainId)) {
            this.chainId = chainId;
            localStorage.setItem("connect-evm-chain-id", this.chainId.toString());
            this.publicClient = this.getPublicClient();
            setTimeout(() => this.events.emit("chainChanged", intToHex2(this.chainId)), 0);
            return Promise.resolve(null);
          }
          throw new SwitchChainError(new Error(`The chain: ${chainId} is not supported`));
        } else {
          throw new InvalidParamsRpcError(new Error("Invalid Params"));
        }
      } else {
        const result = yield this.publicClient.request(arg);
        return result;
      }
    });
  }
  removeListener(event, listener) {
    this.events.removeListener(event, listener);
    return this;
  }
  on(event, listener) {
    this.events.on(event, listener);
    return this;
  }
  once(event, listener) {
    this.events.once(event, listener);
    return this;
  }
  off(event, listener) {
    this.events.off(event, listener);
    return this;
  }
  emit(event, ...args) {
    this.events.emit(event, args);
  }
};

// src/hooks/useModalStateValue.ts
import { useCallback as useCallback7, useState as useState6 } from "react";
var useModalStateValue = () => {
  const [isModalOpen, setModalOpen] = useState6(false);
  return {
    closeModal: useCallback7(() => setModalOpen(false), []),
    isModalOpen,
    openModal: useCallback7(() => setModalOpen(true), [])
  };
};
var useModalStateValue_default = useModalStateValue;

// src/context/index.tsx
import { jsx as jsx9, jsxs as jsxs6 } from "react/jsx-runtime";
var ConnectContext = createContext({});
var SAContractKey = "particle-sa-config";
var ConnectProvider = ({
  children,
  options,
  connectors,
  autoConnect = true
}) => {
  var _a, _b, _c;
  const {
    closeModal: closeConnectModal,
    isModalOpen: connectModalOpen,
    openModal: openConnectModal
  } = useModalStateValue_default();
  const { closeModal: closeSignModal, isModalOpen: signModalOpen, openModal: openSignModal } = useModalStateValue_default();
  const [connectorId, setConnectorId] = useState7();
  const [accounts, setAccounts] = useState7([]);
  const [evmAccount, setEVMAccount] = useState7();
  const [accountContract, _setAccountContract] = useState7({
    name: ((_a = Object.keys(options.aaOptions.accountContracts)) == null ? void 0 : _a[0]) || "BTC",
    version: ((_c = options.aaOptions.accountContracts[((_b = Object.keys(options.aaOptions.accountContracts)) == null ? void 0 : _b[0]) || "BTC"]) == null ? void 0 : _c[0].version) || "1.0.0"
  });
  const setAccountContract = useCallback8(
    (config) => {
      if (!checkBTCVersion(options.aaOptions.accountContracts, config.name, config.version)) {
        throw new Error("Invalid Account Contract");
      }
      localStorage.setItem(SAContractKey, JSON.stringify(config));
      _setAccountContract(config);
    },
    [options.aaOptions.accountContracts, _setAccountContract]
  );
  useEffect5(() => {
    const id = localStorage.getItem("current-connector-id");
    if (autoConnect && id) {
      setConnectorId(id);
    }
  }, [autoConnect]);
  const evmSupportChainIds = useMemo6(() => {
    var _a2;
    let chainIds = (_a2 = options.aaOptions.accountContracts[accountContract.name]) == null ? void 0 : _a2.filter((item) => item.version === accountContract.version).map((item) => item.chainIds).reduce((a, b) => {
      a.push(...b);
      return a;
    }, []);
    chainIds = Array.from(new Set(chainIds || []));
    return chainIds;
  }, [options.aaOptions.accountContracts, accountContract]);
  const connector = useMemo6(() => {
    return connectors.find((item) => item.metadata.id === connectorId);
  }, [connectorId, connectors]);
  const getPublicKey = useCallback8(() => __async(void 0, null, function* () {
    if (!connector) {
      throw new Error("Wallet not connected!");
    }
    const pubKey = yield connector.getPublicKey();
    return pubKey;
  }), [connector]);
  const signMessage = useCallback8(
    (message) => __async(void 0, null, function* () {
      if (!connector) {
        throw new Error("Wallet not connected!");
      }
      const signature = yield connector.signMessage(message);
      return signature;
    }),
    [connector]
  );
  const sendBitcoin = useCallback8(
    (toAddress, satoshis, options2) => __async(void 0, null, function* () {
      if (!connector) {
        throw new Error("Wallet not connected!");
      }
      const signature = yield connector.sendBitcoin(toAddress, satoshis, options2);
      return signature;
    }),
    [connector]
  );
  const getNetwork = useCallback8(() => __async(void 0, null, function* () {
    if (!connector) {
      throw new Error("Wallet not connected!");
    }
    const network = yield connector.getNetwork();
    return network;
  }), [connector]);
  const switchNetwork = useCallback8(
    (network) => __async(void 0, null, function* () {
      if (!connector) {
        throw new Error("Wallet not connected!");
      }
      yield connector.switchNetwork(network);
    }),
    [connector]
  );
  const smartAccount = useMemo6(() => {
    if (typeof window === "undefined") {
      return void 0;
    }
    if (!window.__bitcoinSmartAccount || (window == null ? void 0 : window.__bitcoinSmartAccount) && ((window == null ? void 0 : window.__bitcoinSmartAccount.smartAccountContract.version) !== accountContract.version || (window == null ? void 0 : window.__bitcoinSmartAccount.smartAccountContract.name) !== accountContract.name)) {
      const smartAccount2 = new SmartAccount(
        new AASignerProvider(evmSupportChainIds, options.projectId, options.clientKey, options.rpcUrls),
        options
      );
      smartAccount2.setSmartAccountContract(accountContract);
      window.__bitcoinSmartAccount = smartAccount2;
    }
    window.__bitcoinSmartAccount.provider.getPublicKey = getPublicKey;
    window.__bitcoinSmartAccount.provider.personalSign = signMessage;
    return window.__bitcoinSmartAccount;
  }, [options, evmSupportChainIds, getPublicKey, signMessage, accountContract]);
  useEffect5(() => {
    if (accounts.length > 0 && smartAccount) {
      getBTCAAAddress(smartAccount, accounts[0], accountContract.name, accountContract.version).then((res) => {
        setEVMAccount(res);
      }).catch((e) => {
        setEVMAccount(void 0);
      });
    } else {
      setEVMAccount(void 0);
    }
  }, [accountContract, accounts, smartAccount]);
  const getSmartAccountInfo = useCallback8(() => __async(void 0, null, function* () {
    if (accounts.length > 0 && smartAccount) {
      const accountInfo = yield getBTCAccountInfo(
        smartAccount,
        accounts[0],
        accountContract.name,
        accountContract.version
      );
      setEVMAccount(accountInfo.smartAccountAddress);
      return accountInfo;
    }
    return void 0;
  }), [accounts, smartAccount, accountContract, setEVMAccount]);
  const requestAccount = useCallback8(
    (connector2) => __async(void 0, null, function* () {
      let accounts2 = yield connector2.getAccounts();
      if (accounts2.length === 0 && autoConnect) {
        accounts2 = yield connector2.requestAccounts();
      }
      setAccounts(accounts2);
    }),
    [autoConnect]
  );
  useEffect5(() => {
    if (connector) {
      requestAccount(connector).catch((e) => {
        setAccounts([]);
      });
    } else {
      setAccounts([]);
    }
  }, [connector, requestAccount]);
  useEffect5(() => {
    const onAccountChange = (accounts2) => {
      setAccounts(accounts2);
    };
    connector == null ? void 0 : connector.on("accountsChanged", onAccountChange);
    return () => {
      connector == null ? void 0 : connector.removeListener("accountsChanged", onAccountChange);
    };
  }, [connector]);
  const provider = useMemo6(() => {
    var _a2;
    if (connectorId) {
      return (_a2 = connectors.find((item) => item.metadata.id === connectorId)) == null ? void 0 : _a2.getProvider();
    }
  }, [connectorId, connectors]);
  const disconnect = useCallback8(() => {
    localStorage.removeItem("current-connector-id");
    txConfirmUtils_default.reset();
    if (connector) {
      connector.disconnect();
    }
    setConnectorId(void 0);
  }, [connector]);
  useEffect5(() => {
    const config = JSON.parse(localStorage.getItem(SAContractKey) || "{}");
    if (config.name && config.version && checkBTCVersion(options.aaOptions.accountContracts, config.name, config.version)) {
      _setAccountContract(config);
    }
  }, [options.aaOptions.accountContracts, _setAccountContract]);
  useEffect5(() => {
    var _a2, _b2;
    if (((_a2 = options.walletOptions) == null ? void 0 : _a2.visible) !== false) {
      const supportChains = evmSupportChainIds.map((id) => chains4.getEVMChainInfoById(id));
      if (supportChains.some((chain) => !chain)) {
        throw new Error(`Please config valid chain ids, ${JSON.stringify(evmSupportChainIds)}`);
      }
      walletEntryPlugin.init(
        {
          projectId: options.projectId,
          clientKey: options.clientKey,
          appId: options.appId
        },
        __spreadProps(__spreadValues({}, options.walletOptions), {
          erc4337: accountContract,
          customStyle: __spreadProps(__spreadValues({}, (_b2 = options.walletOptions) == null ? void 0 : _b2.customStyle), {
            supportChains
          })
        })
      );
    }
  }, [options, evmSupportChainIds, accountContract]);
  useEffect5(() => {
    var _a2;
    if (smartAccount && ((_a2 = options.walletOptions) == null ? void 0 : _a2.visible) !== false) {
      walletEntryPlugin.setWalletCore({
        ethereum: smartAccount.provider
      });
    }
  }, [smartAccount, options]);
  useEffect5(() => {
    var _a2;
    if (((_a2 = options.walletOptions) == null ? void 0 : _a2.visible) !== false) {
      if (evmAccount) {
        walletEntryPlugin.walletEntryCreate();
      } else {
        walletEntryPlugin.walletEntryDestroy();
      }
    }
  }, [evmAccount, smartAccount, options]);
  useEffect5(() => {
    if (accounts.length === 0) {
      closeConnectModal();
      closeSignModal();
      if (eventUtils_default.listenerCount("sendUserOpResult" /* sendUserOpResult */) > 0) {
        eventUtils_default.emit("sendUserOpResult" /* sendUserOpResult */, {
          error: {
            code: -32600,
            message: "Wallet disconnected"
          }
        });
      } else if (eventUtils_default.listenerCount("personalSignResult" /* personalSignResult */) > 0) {
        eventUtils_default.emit("personalSignResult" /* personalSignResult */, {
          error: {
            code: -32600,
            message: "Wallet disconnected"
          }
        });
      } else if (eventUtils_default.listenerCount("signTypedDataResult" /* signTypedDataResult */) > 0) {
        eventUtils_default.emit("signTypedDataResult" /* signTypedDataResult */, {
          error: {
            code: -32600,
            message: "Wallet disconnected"
          }
        });
      }
    }
  }, [accounts, closeConnectModal, closeSignModal]);
  return /* @__PURE__ */ jsxs6(
    ConnectContext.Provider,
    {
      value: {
        connectorId,
        setConnectorId,
        connector,
        connectors,
        openConnectModal,
        closeConnectModal,
        accounts,
        provider,
        disconnect,
        getPublicKey,
        signMessage,
        evmAccount,
        smartAccount,
        getNetwork,
        switchNetwork,
        sendBitcoin,
        accountContract,
        setAccountContract,
        getSmartAccountInfo
      },
      children: [
        children,
        /* @__PURE__ */ jsx9(connectModal_default, { open: connectModalOpen, onClose: closeConnectModal }),
        /* @__PURE__ */ jsx9(signModal_default, { open: signModalOpen, onClose: closeSignModal, onOpen: openSignModal })
      ]
    }
  );
};
var useConnectProvider = () => {
  const context = useContext(ConnectContext);
  return context;
};

// src/index.ts
var getVersion = () => {
  return "1.0.0-alpha.26";
};
if (typeof window !== "undefined") {
  window.__PARTICLE_BTC_CONNECT_VERSION = getVersion();
}
export {
  BaseConnector,
  BitgetConnector,
  BybitConnector,
  ConnectProvider,
  InjectedConnector,
  OKXConnector,
  TokenPocketConnector,
  UnisatConnector,
  WizzConnector,
  XverseConnector,
  getVersion,
  useAccountContract,
  useAccounts,
  useBTCProvider,
  useConnectModal,
  useConnector,
  useETHProvider
};
//# sourceMappingURL=index.js.map
